<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="chat-box users">
        <div class="search">
          <div class="position-relative search-row">
              <!-- icon search giữ nguyên -->
              <svg role="button" @click="onSearch"
                xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                <path fill="currentColor"
                  d="M10.77 18.3a7.53 7.53 0 1 1 7.53-7.53a7.53 7.53 0 0 1-7.53 7.53m0-13.55a6 6 0 1 0 6 6a6 6 0 0 0-6-6" />
                <path fill="currentColor"
                  d="M20 20.75a.74.74 0 0 1-.53-.22l-4.13-4.13a.75.75 0 0 1 1.06-1.06l4.13 4.13a.75.75 0 0 1 0 1.06a.74.74 0 0 1-.53.22" />
              </svg>

              <!-- input + filter -->
              <div class="search-input-wrap">
                <input
                  type="text"
                  v-model="keyword"
                  @input="handleInput($event)"
                  placeholder="Search by name, phone number, email…"
                  class="w-100"
                />

                <!-- FILTER: nằm sau input -->
                <div class="filter-wrap">
  <img
    class="filter-icon"
    :src="Icon_filter"
    @click.stop="toggleFilterPanel"
  />

  <!-- 🔴 red dot -->
  <span
    v-if="isFiltering"
    class="filter-dot"
  ></span>
</div>

                  <div v-if="showFilterPanel" class="filter-panel" @click.stop>
                      <div class="filter-header">
                        <div class="filter-title">Filter tags</div>
                        <button class="filter-close" @click.stop="showFilterPanel = false">✕</button>
                      </div>

                      <div class="filter-options">
                        <label v-for="t in tagMaster" :key="t" class="filter-option">
                          <input class="filter-check" type="checkbox" :value="t" v-model="selectedTagFilters" />
                          <span class="filter-label">{{ t.value }}</span>
                        </label>
                      </div>

                      <div class="filter-footer">
                        <button class="btn-lite" @click="clearTagFilters">Clear</button>
                        <button class="btn-primary" @click="applyTagFilters">Apply</button>
                      </div>
                   

                </div>
              </div>
            </div>

          
        </div>
        <div ref="chatConversationRef" @scroll="handleConversationScroll" class="user-card-container">
          <div v-if="!$store.state.socket.connected" class="text-center">Loading...</div>
          <div v-else-if="
            list_conversation.length == 0 ||
            list_conversation.conversations.length == 0
          ">
            <div class="text-center">No data</div>
          </div>
          <div v-else :class="[
            'user-card d-flex justify-content-between cursor-pointer',
            {
              active:
                conversation_active && item._id == conversation_active._id,
            },
          ]" v-for="(item, index) in list_conversation.conversations" :key="`${index}-${item._id}`"
            @click="changeConversation(item)">
            <div class="thumb flex-shrink-0">
              <img v-if="item.users.length > 0 && item.users[0].avatar" class="w-100 h-100"
                :src="item.users[0].avatar" alt="User" />
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40" class="w-100 h-100"
                viewBox="0 0 120 120">
                <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                  <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60"
                    transform="translate(16 228)" fill="#2c2c2f" />
                  <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                    <rect id="Rectangle_3421" data-name="Rectangle 3421" width="80" height="80"
                      fill="rgba(255,255,255,0)" />
                    <g id="Group_9146" data-name="Group 9146">
                      <rect id="Rectangle_3421-2" data-name="Rectangle 3421" width="80" height="80"
                        fill="rgba(255,255,255,0)" />
                      <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                        <circle id="Ellipse_4" data-name="Ellipse 4" cx="15.439" cy="15.439" r="15.439"
                          transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d" stroke-width="1.5" />
                        <path id="Path_5278" data-name="Path 5278"
                          d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z"
                          transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d" stroke-linecap="round"
                          stroke-width="1.5" />
                        <path id="Path_5292" data-name="Path 5292"
                          d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z"
                          transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d" stroke-linecap="round"
                          stroke-width="1.5" />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="info flex-fill">
              <h5 class="line-1">{{ item.title }}</h5>
              <p class="line-1">
                {{
                  item.last_message
                    ? item.last_message.type == 'pdf' ? '[PDF]'
                      : item.last_message.type == 'media' &&
                        (item.last_message.message == '' ||
                          item.last_message.message == null)
                        ? '[Image/Video]'
                        : item.last_message.message
                    : 'No message'
                }}
              </p>
              <div
  class="chat-tags-left"
  v-if="getConversationTags(item).length > 0"
>
  <span
    class="chat-tag-item-left"
    v-for="(tag, index) in getConversationTags(item)"
    :key="index" :style="{ color: tag.text_color, backgroundColor: tag.color }"
  >
    {{ tag.value }}
  </span>
</div>

               <!-- <div class="chat-tags-left" v-if="item.users.length > 0" >
                <span class="chat-tag-item-left">{{ item.users[0].tag_str }}</span>
                <span class="chat-tag-item-left">121324</span>
                <span class="chat-tag-item-left">121324</span>
                <span class="chat-tag-item-left">121324</span>
              </div> -->
              
            </div>
            <div class="notification-timestamp flex-shrink-0">
              <span v-if="item.last_message" class="timestamp">{{
                formatDateTime(item.last_message.created, 'HH:mm')
              }}</span>
              <span v-if="item.unread" class="badge">{{
                `${item.unread > 99 ? item.unread + '+' : item.unread}`
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-box contents position-relative">
        <div v-if="!$store.state.socket.connected" class="text-center-absolute">Loading...</div>
        <div v-else-if="!conversation_active" class="text-center-absolute">
          Please choose a conversation
        </div>
        <div v-else class="content-container h-100 d-flex flex-column">
          <div class="content-header flex-shink-0 d-flex justify-content-between align-items-center">
            <div class="user-info d-flex align-items-center">
              <div class="thumb">
                <img v-if="conversation_active.users.length > 0 &&
                  conversation_active.users[0].avatar" class="w-100 h-100" :src="conversation_active.users[0].avatar"
                  alt="User" />
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40" class="w-100 h-100"
                  viewBox="0 0 120 120">
                  <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                    <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60"
                      transform="translate(16 228)" fill="#2c2c2f" />
                    <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                      <rect id="Rectangle_3421" data-name="Rectangle 3421" width="80" height="80"
                        fill="rgba(255,255,255,0)" />
                      <g id="Group_9146" data-name="Group 9146">
                        <rect id="Rectangle_3421-2" data-name="Rectangle 3421" width="80" height="80"
                          fill="rgba(255,255,255,0)" />
                        <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                          <circle id="Ellipse_4" data-name="Ellipse 4" cx="15.439" cy="15.439" r="15.439"
                            transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d" stroke-width="1.5" />
                          <path id="Path_5278" data-name="Path 5278"
                            d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z"
                            transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d" stroke-linecap="round"
                            stroke-width="1.5" />
                          <path id="Path_5292" data-name="Path 5292"
                            d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z"
                            transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                            stroke-linecap="round" stroke-width="1.5" />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <h5 class="user-name">
                {{ conversation_active ? conversation_active.title : '' }}
              </h5>
               <span
                  v-if="conversation_active && conversation_active.users.length > 0"
                  class="user-info-tooltip"
                  @click="showCustomerInfo = true"
                  style="display: inline-flex; align-items: center; cursor: pointer; font-size: 18px; width: 22px; height: 22px; justify-content: center; border-radius: 50%; background: #eee; color: #333; border: 1px solid #ccc; margin-left: 8px;"
                  title="Customer Info"
                >
                  i
                </span>

                <div
                v-if="conversation_active"
                class="chat-tags d-flex align-items-center"
              >
                <span
                  v-for="(t, idx) in (conversation_active.tags || [])"
                  :key="`${t.key}-${idx}`"
                  class="chat-tag"
                  :style="{ color: t.text_color, backgroundColor: t.color }"
                >
                  {{ t.value }}
                  <span class="chat-tag-x" role="button" @click.stop="removeTag(t.key)">×</span>
                </span>

                <div @click.stop="openTagDialog" :disabled="isSavingTags || tagSelectedToAdd.length === 0">
                   <img style="cursor: pointer;width:20px;height:20px" :src="icon_add_tag">
                </div>
                <!-- <button
                  type="button" 
                  class="chat-tag-add"
                  @click.stop="openTagDialog"
                  title="Add tag"
                >
                  +
                </button> -->
              </div>
            </div>
            <ul class="user-stats d-flex align-items-center">
              <li>
               <Dialog
                header="Add tags"
                :visible.sync="showTagDialog"
                :modal="true"
                :contentStyle="{ overflow: 'visible', width: '420px' }"
                style="z-index: 9999"
              >
                <div class="tag-dialog">
                  <div class="mb-2" style="font-weight: 600;">Select tags</div>

                  <MultiSelect
                v-model="tagSelectedToAdd"
                :options="availableTagOptions"
                optionLabel="value"
                optionValue="key"
                placeholder="Choose tags..."
                :filter="true"
                display="chip"
                class="w-100"
              />


                  <div class="d-flex justify-content-end mt-3">
                    <button class="btn-cancel" type="button" @click="closeTagDialog">Cancel</button>
                    <button
                      class="btn-ok"
                      type="button"
                      :disabled="tagSelectedToAdd.length === 0"
                      @click="confirmAddTags"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </Dialog>

                <Dialog
                  header="Customer Info"
                  :visible.sync="showCustomerInfo"
                  :modal="true"
                  :contentStyle="{ overflow: 'visible',maxHeight: '80vh', overflowY: 'auto',width: '400px' }"
                  style="z-index: 9999"
                >
                  <div style="display: flex; flex-direction: column; align-items: center; padding: 12px 0;">
                    <img
                      v-if="conversation_active.users[0].avatar"
                      :src="conversation_active.users[0].avatar"
                      alt="Avatar"
                      style="width: 80px; height: 80px; border-radius: 50%; object-fit: cover; margin-bottom: 16px;"
                    />
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="80" height="80" style="margin-bottom: 16px;" viewBox="0 0 120 120">
                      <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                        <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60" transform="translate(16 228)" fill="#2c2c2f" />
                        <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                          <rect id="Rectangle_3421" data-name="Rectangle_3421" width="80" height="80" fill="rgba(255,255,255,0)" />
                          <g id="Group_9146" data-name="Group 9146">
                            <rect id="Rectangle_3421-2" data-name="Rectangle_3421" width="80" height="80" fill="rgba(255,255,255,0)" />
                            <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                              <circle id="Ellipse_4" data-name="Ellipse_4" cx="15.439" cy="15.439" r="15.439" transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d" stroke-width="1.5" />
                              <path id="Path_5278" data-name="Path_5278" d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z" transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d" stroke-linecap="round" stroke-width="1.5" />
                              <path id="Path_5292" data-name="Path_5292" d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z" transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d" stroke-linecap="round" stroke-width="1.5" />
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <div style="width: 100%; text-align: center;">
                      <div style="margin-bottom: 8px;"><b>Name:</b> {{ conversation_active.users[0].user_name || 'N/A' }}</div>
                      <div style="margin-bottom: 8px;"><b>Email:</b> {{ conversation_active.users[0].email || 'N/A' }}</div>
                      <div><b>Phone:</b> {{ conversation_active.users[0].phone || 'N/A' }}</div>
                    </div>
                  </div>
                </Dialog>
              </li>
              <li>
                <span>Rental: </span>
                <span>{{ rentalTotal }}</span>
              </li>
            </ul>
          </div>
          <div ref="chatContentRef" @scroll="handleChatScroll" class="content-body flex-fill"
            :style="{ marginBottom: isBoxReply ? '50px' : '0px' }">
            <div class="chat-content-list overflow-y">
              <div :id="`${keyClass}___${item._id}`" :position="index" class="message-item-container"
                v-for="(item, index) in list_message" :key="item._id">
                <template v-if="item.type == 'unread'">
                  <div class="unread-divider">
                    <span class="divider-line"></span>
                    <span class="divider-text">Unread messages</span>
                    <span class="divider-line"></span>
                  </div>
                </template>
                <template v-if="item.type == 'time'">
                  <div class="date-divider">
                    <span>{{ item.text }}</span>
                  </div>
                </template>
                <template v-else-if="item.payload">
                  <div v-if="
                    item.payload.type &&
                    item.payload.type.toLowerCase() == 'rent'
                  " class="message-item message-item-product text-center">
                    <div class="message-max-width d-inline-block w-100">
                      <div class="product-card d-flex align-items-center">
                        <div class="thumb flex-shrink-0">
                          <img class="w-100" :src="getItemFromPayload(
                            item.payload,
                            'cover_img.url'
                          )
                            " />
                        </div>
                        <div class="info flex-fill">
                          <div class="title d-flex line-1">
                            <span class="type flex-shrink-0">[Rent]</span>
                            <div class="brand text-left text-truncate flex-fill">
                              {{
                                getItemFromPayload(
                                  item.payload,
                                  'vehicle_category_name'
                                )
                              }}
                            </div>
                          </div>
                          <div class="price text-left">
                            {{ item.payload.price }}
                          </div>
                        </div>
                        <a v-if="!$commonFuction.isEmpty(item.payload.car)" target="_blank" :href="`${clientDomain}rent/${item.payload.car.slug}`">
                          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="25" viewBox="0 0 16 16">
                            <circle cx="8" cy="8" r="8" fill="#f1f1f1" />
                            <path
                              d="M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                              fill="#999999" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="
                    item.payload.type &&
                    item.payload.type.toLowerCase() == 'buy'
                  " class="message-item message-item-product text-center">
                    <div class="message-max-width d-inline-block w-100">
                      <div class="product-card d-flex align-items-center">
                        <div class="thumb flex-shrink-0">
                          <img class="w-100" :src="getItemFromPayload(
                            item.payload,
                            'cover_img.url'
                          )
                            " />
                        </div>
                        <div class="info flex-fill">
                          <div class="title d-flex line-1">
                            <span class="type flex-shrink-0">[Buy]</span>
                            <div class="brand text-left text-truncate flex-fill">
                              {{
                                getItemFromPayload(
                                  item.payload,
                                  'name'
                                )
                              }}
                            </div>
                          </div>
                          <div class="price text-left">
                            {{ item.payload.price }}
                          </div>
                        </div>
                        <a target="_blank" :href="`${clientDomain}buy/${item.payload.car.slug}`">
                          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="25" viewBox="0 0 16 16">
                            <circle cx="8" cy="8" r="8" fill="#f1f1f1" />
                            <path
                              d="M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                              fill="#999999" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.message" class="message-item message-item-other">
                    <div class="message-max-width">
                      <div class="d-flex justify-content-between">
                        <div class="thumb flex-shrink-0">
                          <img v-if="item.from.avatar" class="w-100 h-100" :src="item.from.avatar" alt="User" />
                          <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40" class="w-100 h-100"
                            viewBox="0 0 120 120">
                            <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                              <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60"
                                transform="translate(16 228)" fill="#2c2c2f" />
                              <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                                <rect id="Rectangle_3421" data-name="Rectangle 3421" width="80" height="80"
                                  fill="rgba(255,255,255,0)" />
                                <g id="Group_9146" data-name="Group 9146">
                                  <rect id="Rectangle_3421-2" data-name="Rectangle 3421" width="80" height="80"
                                    fill="rgba(255,255,255,0)" />
                                  <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                                    <circle id="Ellipse_4" data-name="Ellipse 4" cx="15.439" cy="15.439" r="15.439"
                                      transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d"
                                      stroke-width="1.5" />
                                    <path id="Path_5278" data-name="Path 5278"
                                      d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z"
                                      transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                      stroke-linecap="round" stroke-width="1.5" />
                                    <path id="Path_5292" data-name="Path 5292"
                                      d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z"
                                      transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                      stroke-linecap="round" stroke-width="1.5" />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div class="other-info flex-fill w-100">
                          <div class="other-name">
                            {{ item.from.user_name }}
                          </div>
                          <div class="d-inline-block">
                            <div class="message-info d-flex flex-column align-items-start">
                              <div class="message-text" v-html="highlightedLink(item.message).message"></div>
                              <div class="message-action d-flex justify-content-between align-items-center w-100">
                                <span>{{
                                  formatDateTime(
                                    item.created,
                                    item.show_full_date
                                      ? 'DD/MM/YYYY HH:mm'
                                      : 'HH:mm'
                                  )
                                }}</span>
                                <span role="button" class="reply-action ml-2"
                                  @click="() => openReply(item)">Reply</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="item.from && item.from._id === userLogin.uid">
                  <template v-if="item.type === 'text'">
                    <div v-if="!item.reply" class="message-item message-item-me">
                      <div class="message-max-width d-inline-block">
                        <div class="message-info d-flex flex-column align-items-start">
                          <div class="message-text" v-html="highlightedLink(item.message).message"></div>
                          <div class="message-action d-flex justify-content-between align-items-center w-100">
                            <span>{{
                              formatDateTime(
                                item.created,
                                item.show_full_date
                                  ? 'DD/MM/YYYY HH:mm'
                                  : 'HH:mm'
                              )
                            }}</span>
                            <span role="button" class="reply-action ml-2" @click="() => openReply(item)">Reply</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template v-else>
                      <div v-if="item.reply.type == 'text'" class="message-item message-item-me message-item-reply">
                        <div class="message-max-width d-inline-block">
                          <div class="message-info d-flex flex-column align-items-start">
                            <div class="reply-box position-relative w-100" role="button"
                              @click="() => onMoveToReply(item.reply._id)">
                              <div class="reply-name">
                                {{
                                  item.reply.from._id == userLogin.uid
                                    ? 'You'
                                    : item.reply.from.user_name
                                }}
                              </div>
                              <div class="reply-desc text-truncate">
                                {{ item.reply.message }}
                              </div>
                            </div>
                            <div class="message-text" v-html="highlightedLink(item.message).message"></div>
                            <div class="message-action d-flex justify-content-between align-items-center w-100">
                              <span>{{
                                formatDateTime(
                                  item.created,
                                  item.show_full_date
                                    ? 'DD/MM/YYYY HH:mm'
                                    : 'HH:mm'
                                )
                              }}</span>
                              <span role="button" class="reply-action ml-2"
                                @click="() => openReply(item)">Reply</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="item.reply.type == 'pdf'"
                        class="message-item message-item-me message-item-reply message-item-reply-pdf">
                        <div class="message-max-width d-inline-block">
                          <div class="message-info">
                            <div class="reply-box d-flex position-relative w-100" role="button"
                              @click="() => onMoveToReply(item.reply._id)">
                              <span class="flex-shrink-0 document d-flex align-items-center justify-content-center">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                  fill="#FAE0A0" width="16" height="16" viewBox="0 0 256 256" xml:space="preserve">
                                  <defs></defs>
                                  <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                                    <path
                                      d="M 77.474 17.28 L 61.526 1.332 C 60.668 0.473 59.525 0 58.311 0 H 15.742 c -2.508 0 -4.548 2.04 -4.548 4.548 v 80.904 c 0 2.508 2.04 4.548 4.548 4.548 h 58.516 c 2.508 0 4.549 -2.04 4.549 -4.548 V 20.496 C 78.807 19.281 78.333 18.138 77.474 17.28 z M 61.073 5.121 l 12.611 12.612 H 62.35 c -0.704 0 -1.276 -0.573 -1.276 -1.277 V 5.121 z M 74.258 87 H 15.742 c -0.854 0 -1.548 -0.694 -1.548 -1.548 V 4.548 C 14.194 3.694 14.888 3 15.742 3 h 42.332 v 13.456 c 0 2.358 1.918 4.277 4.276 4.277 h 13.457 v 64.719 C 75.807 86.306 75.112 87 74.258 87 z"
                                      transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                    <path
                                      d="M 26.806 75.278 c -1.29 0 -2.11 -0.732 -2.473 -1.15 l -0.14 -0.162 l -0.089 -0.193 c -0.854 -1.853 -1.232 -4.745 1.809 -8.01 c 2.483 -2.666 6.624 -4.957 11.318 -6.697 c 1.585 -2.964 3.067 -6.128 4.265 -9.157 c -2.997 -4.992 -4.234 -10.248 -2.971 -13.719 c 0.709 -1.948 2.179 -3.174 4.14 -3.452 l 0.211 -0.015 c 2.147 0 3.689 1.282 4.232 3.516 c 0.729 3.003 -0.306 7.954 -2.271 13.335 c 0.745 1.108 1.601 2.216 2.567 3.293 c 0.912 1.101 1.842 2.1 2.771 2.999 c 5.057 -0.67 9.654 -0.562 12.521 0.52 c 3.231 1.219 3.771 3.396 3.804 4.586 l 0.001 0.03 c 0.016 1.91 -0.942 3.359 -2.63 3.976 c -3.511 1.286 -9.379 -1.229 -14.678 -5.943 c -3.251 0.526 -6.669 1.374 -9.849 2.472 c -3.526 6.359 -7.529 11.694 -10.478 13.216 C 28.081 75.126 27.395 75.278 26.806 75.278 z M 26.714 72.252 c 0.112 0.046 0.321 0.038 0.776 -0.197 c 1.955 -1.009 4.643 -4.384 7.299 -8.718 c -2.787 1.308 -5.143 2.82 -6.681 4.471 C 26.094 69.97 26.427 71.524 26.714 72.252 z M 53.291 58.535 c 4.155 3.122 7.893 4.232 9.55 3.624 c 0.321 -0.117 0.662 -0.31 0.659 -1.119 c -0.01 -0.333 -0.063 -1.169 -1.864 -1.849 C 59.685 58.454 56.703 58.272 53.291 58.535 z M 43.53 52.896 c -0.677 1.611 -1.421 3.235 -2.208 4.829 c 1.733 -0.499 3.498 -0.924 5.243 -1.266 c -0.488 -0.526 -0.967 -1.072 -1.432 -1.634 C 44.57 54.198 44.035 53.553 43.53 52.896 z M 42.982 35.724 c -0.531 0.094 -1.232 0.375 -1.639 1.492 c -0.705 1.937 -0.214 5.265 1.519 8.907 c 1.234 -3.82 1.822 -7.146 1.329 -9.176 C 43.936 35.892 43.479 35.739 42.982 35.724 z"
                                      transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                  </g>
                                </svg>
                              </span>
                              <div class="reply-info">
                                <div class="reply-name">
                                  {{
                                    item.reply.from._id == userLogin.uid
                                      ? 'You'
                                      : item.reply.from.user_name
                                  }}
                                </div>
                                <div class="reply-desc text-truncate">
                                  {{
                                    getFileNameFromPath(
                                      item.reply.files[0].path
                                    )
                                  }}
                                </div>
                              </div>
                            </div>
                            <div class="message-text" v-html="highlightedLink(item.message).message"></div>
                            <div class="message-action d-flex justify-content-between align-items-center w-100">
                              <span>{{
                                formatDateTime(
                                  item.created,
                                  item.show_full_date
                                    ? 'DD/MM/YYYY HH:mm'
                                    : 'HH:mm'
                                )
                              }}</span>
                              <span role="button" class="reply-action ml-2"
                                @click="() => openReply(item)">Reply</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="item.reply.type == 'media'"
                        class="message-item message-item-me message-item-reply">
                        <div class="message-max-width d-inline-block">
                          <div class="message-info d-flex flex-column align-items-start">
                            <div class="reply-box d-flex align-items-center position-relative w-100" role="button"
                              @click="() => onMoveToReply(item.reply._id)">
                              <div class="thumb">
                                <img class="w-100 h-100" :src="item.reply.files[0].thumb" />
                              </div>
                              <div class="reply-info">
                                <div class="reply-name">
                                  {{
                                    item.reply.from._id == userLogin.uid
                                      ? 'You'
                                      : item.reply.from.user_name
                                  }}
                                </div>
                                <div class="reply-desc text-truncate">
                                  {{ item.reply.message ? item.reply.message : (item.reply.files.length > 0 &&
                                    item.reply.files[0].type === 'image' ? '[Image]' : '[Video]') }}
                                </div>
                              </div>
                            </div>
                            <div class="message-text" v-html="highlightedLink(item.message).message"></div>
                            <div class="message-action d-flex justify-content-between align-items-center w-100">
                              <span>{{
                                formatDateTime(
                                  item.created,
                                  item.show_full_date
                                    ? 'DD/MM/YYYY HH:mm'
                                    : 'HH:mm'
                                )
                              }}</span>
                              <span role="button" class="reply-action ml-2"
                                @click="() => openReply(item)">Reply</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                  <template v-else-if="item.type === 'pdf'">
                    <div v-if="item.files.length > 0" class="message-item message-item-me message-item-pdf">
                      <div class="message-max-width d-inline-block w-100">
                        <div class="message-info d-flex flex-column align-items-start">
                          <div class="pdf-info d-flex align-items-center justify-content-between w-100">
                            <span class="flex-shrink-0 document d-flex align-items-center justify-content-center">
                              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                fill="#FAE0A0" width="16" height="16" viewBox="0 0 256 256" xml:space="preserve">
                                <defs></defs>
                                <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                                  <path
                                    d="M 77.474 17.28 L 61.526 1.332 C 60.668 0.473 59.525 0 58.311 0 H 15.742 c -2.508 0 -4.548 2.04 -4.548 4.548 v 80.904 c 0 2.508 2.04 4.548 4.548 4.548 h 58.516 c 2.508 0 4.549 -2.04 4.549 -4.548 V 20.496 C 78.807 19.281 78.333 18.138 77.474 17.28 z M 61.073 5.121 l 12.611 12.612 H 62.35 c -0.704 0 -1.276 -0.573 -1.276 -1.277 V 5.121 z M 74.258 87 H 15.742 c -0.854 0 -1.548 -0.694 -1.548 -1.548 V 4.548 C 14.194 3.694 14.888 3 15.742 3 h 42.332 v 13.456 c 0 2.358 1.918 4.277 4.276 4.277 h 13.457 v 64.719 C 75.807 86.306 75.112 87 74.258 87 z"
                                    transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                  <path
                                    d="M 26.806 75.278 c -1.29 0 -2.11 -0.732 -2.473 -1.15 l -0.14 -0.162 l -0.089 -0.193 c -0.854 -1.853 -1.232 -4.745 1.809 -8.01 c 2.483 -2.666 6.624 -4.957 11.318 -6.697 c 1.585 -2.964 3.067 -6.128 4.265 -9.157 c -2.997 -4.992 -4.234 -10.248 -2.971 -13.719 c 0.709 -1.948 2.179 -3.174 4.14 -3.452 l 0.211 -0.015 c 2.147 0 3.689 1.282 4.232 3.516 c 0.729 3.003 -0.306 7.954 -2.271 13.335 c 0.745 1.108 1.601 2.216 2.567 3.293 c 0.912 1.101 1.842 2.1 2.771 2.999 c 5.057 -0.67 9.654 -0.562 12.521 0.52 c 3.231 1.219 3.771 3.396 3.804 4.586 l 0.001 0.03 c 0.016 1.91 -0.942 3.359 -2.63 3.976 c -3.511 1.286 -9.379 -1.229 -14.678 -5.943 c -3.251 0.526 -6.669 1.374 -9.849 2.472 c -3.526 6.359 -7.529 11.694 -10.478 13.216 C 28.081 75.126 27.395 75.278 26.806 75.278 z M 26.714 72.252 c 0.112 0.046 0.321 0.038 0.776 -0.197 c 1.955 -1.009 4.643 -4.384 7.299 -8.718 c -2.787 1.308 -5.143 2.82 -6.681 4.471 C 26.094 69.97 26.427 71.524 26.714 72.252 z M 53.291 58.535 c 4.155 3.122 7.893 4.232 9.55 3.624 c 0.321 -0.117 0.662 -0.31 0.659 -1.119 c -0.01 -0.333 -0.063 -1.169 -1.864 -1.849 C 59.685 58.454 56.703 58.272 53.291 58.535 z M 43.53 52.896 c -0.677 1.611 -1.421 3.235 -2.208 4.829 c 1.733 -0.499 3.498 -0.924 5.243 -1.266 c -0.488 -0.526 -0.967 -1.072 -1.432 -1.634 C 44.57 54.198 44.035 53.553 43.53 52.896 z M 42.982 35.724 c -0.531 0.094 -1.232 0.375 -1.639 1.492 c -0.705 1.937 -0.214 5.265 1.519 8.907 c 1.234 -3.82 1.822 -7.146 1.329 -9.176 C 43.936 35.892 43.479 35.739 42.982 35.724 z"
                                    transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                </g>
                              </svg>
                            </span>
                            <div class="text-truncate title">
                              {{ getFileNameFromPath(item.files[0].path) }}
                            </div>
                            <span role="button" @click="() => downLoadFileWithPath(item.files[0].path)
                              " class="flex-shrink-0 d-flex align-items-center justify-content-center">
                              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#000"
                                viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                  d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1z" />
                                <path fill-rule="evenodd"
                                  d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                              </svg>
                            </span>
                          </div>
                        </div>
                        <div class="message-action d-inline-block">
                          <span>{{
                            formatDateTime(
                              item.created,
                              item.show_full_date
                                ? 'DD/MM/YYYY HH:mm'
                                : 'HH:mm'
                            )
                          }}</span>
                          <span role="button" @click="() => openReply(item, 'pdf')">Reply</span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="item.type === 'media'">
                    <div v-if="item.message" class="message-item message-item-me">
                      <div class="message-max-width d-inline-block">
                        <div class="message-info d-flex flex-column align-items-start">
                          <div class="message-text" v-html="highlightedLink(item.message).message"></div>
                          <div class="message-action d-flex justify-content-between align-items-center w-100">
                            <span>{{
                              formatDateTime(
                                item.created,
                                item.show_full_date
                                  ? 'DD/MM/YYYY HH:mm'
                                  : 'HH:mm'
                              )
                            }}</span>
                            <span role="button" class="reply-action ml-2" @click="() => openReply(item)">Reply</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="
                      item.files.length > 0 && item.files[0].type === 'image'
                    " class="message-item message-item-me message-item-album"
                      :style="{ marginTop: item.message ? '-10px' : '0' }">
                      <div class="message-max-width d-inline-block">
                        <div class="message-info d-flex flex-column align-items-end">
                          <div class="message-box-album d-flex flex-wrap justify-content-end">
                            <div v-for="item in item.files" :key="item._id" class="album-item flex-shrink-0"
                              role="button" data-fancybox="album" :data-src="item.path">
                              <img class="w-100 h-100" :src="item.thumb" alt="Img" />
                            </div>
                          </div>
                          <div class="d-inline-block timestamp-reply">
                            <span class="timestamp">
                              {{
                                formatDateTime(
                                  item.created,
                                  item.show_full_date
                                    ? 'DD/MM/YYYY HH: mm'
                                    : 'HH: mm'
                                )
                              }}
                            </span>
                            <span v-if="item.files.length == 1" class="reply-action ml-2" role="button"
                              @click="() => openReply(item, 'image')">Reply</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="
                      item.files.length > 0 && item.files[0].type === 'video'
                    " class="message-item message-item-me message-item-album"
                      :style="{ marginTop: item.message ? '-10px' : '0' }">
                      <div class="message-max-width d-inline-block">
                        <div class="message-info d-flex flex-column align-items-end">
                          <div class="message-box-album d-flex flex-wrap justify-content-end">
                            <div v-for="item in item.files" :key="item._id"
                              class="album-item flex-shrink-0 position-relative" role="button" data-fancybox="album"
                              :data-src="item.path" data-type="html5video">
                              <img class="w-100 h-100" :src="item.thumb" alt="Img" />
                              <div class="play-icon d-flex align-items-center justify-content-center" role="button">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff"
                                  viewBox="0 0 16 16">
                                  <path
                                    d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z" />
                                </svg>
                              </div>
                            </div>
                          </div>
                          <div class="d-inline-block timestamp-reply">
                            <span class="timestamp">
                              {{
                                formatDateTime(
                                  item.created,
                                  item.show_full_date
                                    ? 'DD/MM/YYYY HH: mm'
                                    : 'HH: mm'
                                )
                              }}
                            </span>
                            <span v-if="item.files.length == 1" class="reply-action ml-2" role="button"
                              @click="() => openReply(item, 'video')">Reply</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <template v-if="item.type === 'text'">
                    <div v-if="!item.reply" class="message-item message-item-other">
                      <div class="message-max-width">
                        <div class="d-flex justify-content-between">
                          <div class="thumb flex-shrink-0">
                            <img v-if="item.from.avatar" class="w-100 h-100" :src="item.from.avatar" alt="User" />
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40" class="w-100 h-100"
                              viewBox="0 0 120 120">
                              <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                                <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60"
                                  transform="translate(16 228)" fill="#2c2c2f" />
                                <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                                  <rect id="Rectangle_3421" data-name="Rectangle 3421" width="80" height="80"
                                    fill="rgba(255,255,255,0)" />
                                  <g id="Group_9146" data-name="Group 9146">
                                    <rect id="Rectangle_3421-2" data-name="Rectangle 3421" width="80" height="80"
                                      fill="rgba(255,255,255,0)" />
                                    <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                                      <circle id="Ellipse_4" data-name="Ellipse 4" cx="15.439" cy="15.439" r="15.439"
                                        transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-width="1.5" />
                                      <path id="Path_5278" data-name="Path 5278"
                                        d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z"
                                        transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-linecap="round" stroke-width="1.5" />
                                      <path id="Path_5292" data-name="Path 5292"
                                        d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z"
                                        transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-linecap="round" stroke-width="1.5" />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div class="other-info flex-fill w-100">
                            <div class="other-name">
                              {{ item.from.user_name }}
                            </div>
                            <div class="d-inline-block">
                              <div class="message-info d-flex flex-column align-items-start">
                                <div class="message-text" v-html="highlightedLink(item.message).message"></div>
                                <div class="message-action d-flex justify-content-between align-items-center w-100">
                                  <span>{{
                                    formatDateTime(
                                      item.created,
                                      item.show_full_date
                                        ? 'DD/MM/YYYY HH:mm'
                                        : 'HH:mm'
                                    )
                                  }}</span>
                                  <span role="button" class="reply-action ml-2"
                                    @click="() => openReply(item)">Reply</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <template v-else>
                      <template v-if="item.reply.type == 'text'">
                        <div class="message-item message-item-other message-item-reply">
                          <div class="message-max-width d-inline-block">
                            <div class="d-flex">
                              <div class="thumb flex-shrink-0">
                                <img v-if="item.from.avatar" class="w-100 h-100" :src="item.from.avatar" alt="User" />
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                                  class="w-100 h-100" viewBox="0 0 120 120">
                                  <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                                    <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60"
                                      transform="translate(16 228)" fill="#2c2c2f" />
                                    <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                                      <rect id="Rectangle_3421" data-name="Rectangle 3421" width="80" height="80"
                                        fill="rgba(255,255,255,0)" />
                                      <g id="Group_9146" data-name="Group 9146">
                                        <rect id="Rectangle_3421-2" data-name="Rectangle 3421" width="80" height="80"
                                          fill="rgba(255,255,255,0)" />
                                        <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                                          <circle id="Ellipse_4" data-name="Ellipse 4" cx="15.439" cy="15.439"
                                            r="15.439" transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d"
                                            stroke-width="1.5" />
                                          <path id="Path_5278" data-name="Path 5278"
                                            d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z"
                                            transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                            stroke-linecap="round" stroke-width="1.5" />
                                          <path id="Path_5292" data-name="Path 5292"
                                            d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z"
                                            transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                            stroke-linecap="round" stroke-width="1.5" />
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                              </div>
                              <div class="other-info">
                                <div class="other-name">
                                  {{ item.from.user_name }}
                                </div>
                                <div class="message-info d-flex flex-column align-items-start">
                                  <div role="button" class="reply-box position-relative w-100" @click="() => onMoveToReply(item.reply._id)
                                    ">
                                    <div class="reply-name">
                                      {{ getNameChat(item.reply) }}
                                    </div>
                                    <div class="reply-desc text-truncate">
                                      {{ item.reply.message }}
                                    </div>
                                  </div>
                                  <div class="message-text" v-html="highlightedLink(item.message).message"></div>
                                  <div class="message-action d-flex justify-content-between align-items-center w-100">
                                    <span>{{
                                      formatDateTime(
                                        item.created,
                                        item.show_full_date
                                          ? 'DD/MM/YYYY HH:mm'
                                          : 'HH:mm'
                                      )
                                    }}</span>
                                    <span role="button" class="reply-action ml-2"
                                      @click="() => openReply(item)">Reply</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="item.reply.type == 'pdf'">
                        <div class="message-item message-item-other message-item-reply">
                          <div class="message-max-width d-inline-block">
                            <div class="d-flex">
                              <div class="thumb flex-shrink-0">
                                <img v-if="item.from.avatar" class="w-100 h-100" :src="item.from.avatar" alt="User" />
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                                  class="w-100 h-100" viewBox="0 0 120 120">
                                  <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                                    <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60"
                                      transform="translate(16 228)" fill="#2c2c2f" />
                                    <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                                      <rect id="Rectangle_3421" data-name="Rectangle 3421" width="80" height="80"
                                        fill="rgba(255,255,255,0)" />
                                      <g id="Group_9146" data-name="Group 9146">
                                        <rect id="Rectangle_3421-2" data-name="Rectangle 3421" width="80" height="80"
                                          fill="rgba(255,255,255,0)" />
                                        <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                                          <circle id="Ellipse_4" data-name="Ellipse 4" cx="15.439" cy="15.439"
                                            r="15.439" transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d"
                                            stroke-width="1.5" />
                                          <path id="Path_5278" data-name="Path 5278"
                                            d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z"
                                            transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                            stroke-linecap="round" stroke-width="1.5" />
                                          <path id="Path_5292" data-name="Path 5292"
                                            d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z"
                                            transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                            stroke-linecap="round" stroke-width="1.5" />
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                              </div>
                              <div class="other-info">
                                <div class="other-name">
                                  {{ item.reply.from._id == userLogin.uid ? 'You' : item.from.user_name }}
                                </div>
                                <div class="message-info d-flex flex-column align-items-start">
                                  <div class="reply-box d-flex position-relative w-100" role="button" @click="() => onMoveToReply(item.reply._id)
                                    ">
                                    <span
                                      class="flex-shrink-0 document d-flex align-items-center justify-content-center">
                                      <svg xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" fill="#FAE0A0" width="16"
                                        height="16" viewBox="0 0 256 256" xml:space="preserve">
                                        <defs></defs>
                                        <g
                                          transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                                          <path
                                            d="M 77.474 17.28 L 61.526 1.332 C 60.668 0.473 59.525 0 58.311 0 H 15.742 c -2.508 0 -4.548 2.04 -4.548 4.548 v 80.904 c 0 2.508 2.04 4.548 4.548 4.548 h 58.516 c 2.508 0 4.549 -2.04 4.549 -4.548 V 20.496 C 78.807 19.281 78.333 18.138 77.474 17.28 z M 61.073 5.121 l 12.611 12.612 H 62.35 c -0.704 0 -1.276 -0.573 -1.276 -1.277 V 5.121 z M 74.258 87 H 15.742 c -0.854 0 -1.548 -0.694 -1.548 -1.548 V 4.548 C 14.194 3.694 14.888 3 15.742 3 h 42.332 v 13.456 c 0 2.358 1.918 4.277 4.276 4.277 h 13.457 v 64.719 C 75.807 86.306 75.112 87 74.258 87 z"
                                            transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                          <path
                                            d="M 26.806 75.278 c -1.29 0 -2.11 -0.732 -2.473 -1.15 l -0.14 -0.162 l -0.089 -0.193 c -0.854 -1.853 -1.232 -4.745 1.809 -8.01 c 2.483 -2.666 6.624 -4.957 11.318 -6.697 c 1.585 -2.964 3.067 -6.128 4.265 -9.157 c -2.997 -4.992 -4.234 -10.248 -2.971 -13.719 c 0.709 -1.948 2.179 -3.174 4.14 -3.452 l 0.211 -0.015 c 2.147 0 3.689 1.282 4.232 3.516 c 0.729 3.003 -0.306 7.954 -2.271 13.335 c 0.745 1.108 1.601 2.216 2.567 3.293 c 0.912 1.101 1.842 2.1 2.771 2.999 c 5.057 -0.67 9.654 -0.562 12.521 0.52 c 3.231 1.219 3.771 3.396 3.804 4.586 l 0.001 0.03 c 0.016 1.91 -0.942 3.359 -2.63 3.976 c -3.511 1.286 -9.379 -1.229 -14.678 -5.943 c -3.251 0.526 -6.669 1.374 -9.849 2.472 c -3.526 6.359 -7.529 11.694 -10.478 13.216 C 28.081 75.126 27.395 75.278 26.806 75.278 z M 26.714 72.252 c 0.112 0.046 0.321 0.038 0.776 -0.197 c 1.955 -1.009 4.643 -4.384 7.299 -8.718 c -2.787 1.308 -5.143 2.82 -6.681 4.471 C 26.094 69.97 26.427 71.524 26.714 72.252 z M 53.291 58.535 c 4.155 3.122 7.893 4.232 9.55 3.624 c 0.321 -0.117 0.662 -0.31 0.659 -1.119 c -0.01 -0.333 -0.063 -1.169 -1.864 -1.849 C 59.685 58.454 56.703 58.272 53.291 58.535 z M 43.53 52.896 c -0.677 1.611 -1.421 3.235 -2.208 4.829 c 1.733 -0.499 3.498 -0.924 5.243 -1.266 c -0.488 -0.526 -0.967 -1.072 -1.432 -1.634 C 44.57 54.198 44.035 53.553 43.53 52.896 z M 42.982 35.724 c -0.531 0.094 -1.232 0.375 -1.639 1.492 c -0.705 1.937 -0.214 5.265 1.519 8.907 c 1.234 -3.82 1.822 -7.146 1.329 -9.176 C 43.936 35.892 43.479 35.739 42.982 35.724 z"
                                            transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                        </g>
                                      </svg>
                                    </span>
                                    <div class="reply-info">
                                      <div class="reply-name">
                                        {{ getNameChat(item.reply) }}
                                      </div>
                                      <div class="reply-desc text-truncate">
                                        {{
                                          getFileNameFromPath(
                                            item.reply.files[0].path
                                          )
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="message-text" v-html="highlightedLink(item.message).message"></div>
                                  <div class="message-action d-flex justify-content-between align-items-center w-100">
                                    <span>{{
                                      formatDateTime(
                                        item.created,
                                        item.show_full_date
                                          ? 'DD/MM/YYYY HH:mm'
                                          : 'HH:mm'
                                      )
                                    }}</span>
                                    <span role="button" @click="() => openReply(item)">Reply</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="item.reply.type == 'media'">
                        <div class="message-item message-item-other message-item-reply">
                          <div class="message-max-width d-inline-block">
                            <div class="d-flex">
                              <div class="thumb flex-shrink-0">
                                <img v-if="item.from.avatar" class="w-100 h-100" :src="item.from.avatar" alt="User" />
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                                  class="w-100 h-100" viewBox="0 0 120 120">
                                  <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                                    <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60"
                                      transform="translate(16 228)" fill="#2c2c2f" />
                                    <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                                      <rect id="Rectangle_3421" data-name="Rectangle 3421" width="80" height="80"
                                        fill="rgba(255,255,255,0)" />
                                      <g id="Group_9146" data-name="Group 9146">
                                        <rect id="Rectangle_3421-2" data-name="Rectangle 3421" width="80" height="80"
                                          fill="rgba(255,255,255,0)" />
                                        <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                                          <circle id="Ellipse_4" data-name="Ellipse 4" cx="15.439" cy="15.439"
                                            r="15.439" transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d"
                                            stroke-width="1.5" />
                                          <path id="Path_5278" data-name="Path 5278"
                                            d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z"
                                            transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                            stroke-linecap="round" stroke-width="1.5" />
                                          <path id="Path_5292" data-name="Path 5292"
                                            d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z"
                                            transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                            stroke-linecap="round" stroke-width="1.5" />
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                              </div>
                              <div class="other-info">
                                <div class="other-name">{{ item.reply.from._id == userLogin.uid ? 'You'
                                  : item.from.user_name }}</div>
                                <div class="message-info d-flex flex-column align-items-start">
                                  <div class="reply-box d-flex position-relative w-100" role="button"
                                    @click="() => onMoveToReply(item.reply._id)">
                                    <div class="thumb">
                                      <img class="w-100 h-100" :src="item.reply.files[0].thumb" />
                                    </div>
                                    <div class="reply-info">
                                      <div class="reply-name">{{ getNameChat(item.reply) }}</div>
                                      <div class="reply-desc text-truncate">{{ item.reply.message ? item.reply.message
                                        : (item.reply.files.length > 0 && item.reply.files[0].type === 'image' ?
                                          '[Image]' : '[Video]') }}</div>
                                    </div>
                                  </div>
                                  <div class="message-text" v-html="highlightedLink(item.message).message"></div>
                                  <div class="message-action d-flex justify-content-between align-items-center w-100">
                                    <span>{{ formatDateTime(item.created, item.show_full_date ? 'DD/MM/YYYY HH:mm' :
                                      'HH:mm') }}</span>
                                    <span role="button" @click="() => openReply(item)">Reply</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </template>
                  <template v-else-if="item.type === 'pdf'">
                    <div v-if="item.files.length > 0" class="message-item message-item-other message-item-pdf">
                      <div class="message-max-width d-inline-block w-100">
                        <div class="d-flex justify-content-between">
                          <div class="thumb flex-shrink-0">
                            <img v-if="item.from.avatar" class="w-100 h-100" :src="item.from.avatar" alt="User" />
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40" class="w-100 h-100"
                              viewBox="0 0 120 120">
                              <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                                <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60"
                                  transform="translate(16 228)" fill="#2c2c2f" />
                                <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                                  <rect id="Rectangle_3421" data-name="Rectangle 3421" width="80" height="80"
                                    fill="rgba(255,255,255,0)" />
                                  <g id="Group_9146" data-name="Group 9146">
                                    <rect id="Rectangle_3421-2" data-name="Rectangle 3421" width="80" height="80"
                                      fill="rgba(255,255,255,0)" />
                                    <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                                      <circle id="Ellipse_4" data-name="Ellipse 4" cx="15.439" cy="15.439" r="15.439"
                                        transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-width="1.5" />
                                      <path id="Path_5278" data-name="Path 5278"
                                        d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z"
                                        transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-linecap="round" stroke-width="1.5" />
                                      <path id="Path_5292" data-name="Path 5292"
                                        d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z"
                                        transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-linecap="round" stroke-width="1.5" />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div class="other-info flex-fill w-100">
                            <div class="other-name">
                              {{ item.from.user_name }}
                            </div>
                            <div class="message-info d-flex flex-column align-items-start">
                              <div class="pdf-info d-flex align-items-center justify-content-between w-100">
                                <span class="flex-shrink-0 document d-flex align-items-center justify-content-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    fill="#FAE0A0" width="16" height="16" viewBox="0 0 256 256" xml:space="preserve">
                                    <defs></defs>
                                    <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                                      <path
                                        d="M 77.474 17.28 L 61.526 1.332 C 60.668 0.473 59.525 0 58.311 0 H 15.742 c -2.508 0 -4.548 2.04 -4.548 4.548 v 80.904 c 0 2.508 2.04 4.548 4.548 4.548 h 58.516 c 2.508 0 4.549 -2.04 4.549 -4.548 V 20.496 C 78.807 19.281 78.333 18.138 77.474 17.28 z M 61.073 5.121 l 12.611 12.612 H 62.35 c -0.704 0 -1.276 -0.573 -1.276 -1.277 V 5.121 z M 74.258 87 H 15.742 c -0.854 0 -1.548 -0.694 -1.548 -1.548 V 4.548 C 14.194 3.694 14.888 3 15.742 3 h 42.332 v 13.456 c 0 2.358 1.918 4.277 4.276 4.277 h 13.457 v 64.719 C 75.807 86.306 75.112 87 74.258 87 z"
                                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                      <path
                                        d="M 26.806 75.278 c -1.29 0 -2.11 -0.732 -2.473 -1.15 l -0.14 -0.162 l -0.089 -0.193 c -0.854 -1.853 -1.232 -4.745 1.809 -8.01 c 2.483 -2.666 6.624 -4.957 11.318 -6.697 c 1.585 -2.964 3.067 -6.128 4.265 -9.157 c -2.997 -4.992 -4.234 -10.248 -2.971 -13.719 c 0.709 -1.948 2.179 -3.174 4.14 -3.452 l 0.211 -0.015 c 2.147 0 3.689 1.282 4.232 3.516 c 0.729 3.003 -0.306 7.954 -2.271 13.335 c 0.745 1.108 1.601 2.216 2.567 3.293 c 0.912 1.101 1.842 2.1 2.771 2.999 c 5.057 -0.67 9.654 -0.562 12.521 0.52 c 3.231 1.219 3.771 3.396 3.804 4.586 l 0.001 0.03 c 0.016 1.91 -0.942 3.359 -2.63 3.976 c -3.511 1.286 -9.379 -1.229 -14.678 -5.943 c -3.251 0.526 -6.669 1.374 -9.849 2.472 c -3.526 6.359 -7.529 11.694 -10.478 13.216 C 28.081 75.126 27.395 75.278 26.806 75.278 z M 26.714 72.252 c 0.112 0.046 0.321 0.038 0.776 -0.197 c 1.955 -1.009 4.643 -4.384 7.299 -8.718 c -2.787 1.308 -5.143 2.82 -6.681 4.471 C 26.094 69.97 26.427 71.524 26.714 72.252 z M 53.291 58.535 c 4.155 3.122 7.893 4.232 9.55 3.624 c 0.321 -0.117 0.662 -0.31 0.659 -1.119 c -0.01 -0.333 -0.063 -1.169 -1.864 -1.849 C 59.685 58.454 56.703 58.272 53.291 58.535 z M 43.53 52.896 c -0.677 1.611 -1.421 3.235 -2.208 4.829 c 1.733 -0.499 3.498 -0.924 5.243 -1.266 c -0.488 -0.526 -0.967 -1.072 -1.432 -1.634 C 44.57 54.198 44.035 53.553 43.53 52.896 z M 42.982 35.724 c -0.531 0.094 -1.232 0.375 -1.639 1.492 c -0.705 1.937 -0.214 5.265 1.519 8.907 c 1.234 -3.82 1.822 -7.146 1.329 -9.176 C 43.936 35.892 43.479 35.739 42.982 35.724 z"
                                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                    </g>
                                  </svg>
                                </span>
                                <div class="text-truncate title">
                                  {{
                                    getFileNameFromPath(item.files[0].path)
                                  }}
                                </div>
                                <span role="button" @click="() =>
                                  downLoadFileWithPath(item.files[0].path)
                                  " class="flex-shrink-0 d-flex align-items-center justify-content-center">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#000"
                                    viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                      d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1z" />
                                    <path fill-rule="evenodd"
                                      d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                                  </svg>
                                </span>
                              </div>
                            </div>
                            <div class="message-action d-inline-block">
                              <span>{{
                                formatDateTime(
                                  item.created,
                                  item.show_full_date
                                    ? 'DD/MM/YYYY HH:mm'
                                    : 'HH:mm'
                                )
                              }}</span>
                              <span role="button" @click="() => openReply(item, 'pdf')">Reply</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="item.type === 'media'">
                    <div v-if="item.message" class="message-item message-item-other message-item-other-media">
                      <div class="message-max-width">
                        <div class="d-flex justify-content-between">
                          <div class="thumb flex-shrink-0">
                            <img v-if="item.from.avatar" class="w-100 h-100" :src="item.from.avatar" alt="User" />
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40" class="w-100 h-100"
                              viewBox="0 0 120 120">
                              <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                                <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60"
                                  transform="translate(16 228)" fill="#2c2c2f" />
                                <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                                  <rect id="Rectangle_3421" data-name="Rectangle 3421" width="80" height="80"
                                    fill="rgba(255,255,255,0)" />
                                  <g id="Group_9146" data-name="Group 9146">
                                    <rect id="Rectangle_3421-2" data-name="Rectangle 3421" width="80" height="80"
                                      fill="rgba(255,255,255,0)" />
                                    <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                                      <circle id="Ellipse_4" data-name="Ellipse 4" cx="15.439" cy="15.439" r="15.439"
                                        transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-width="1.5" />
                                      <path id="Path_5278" data-name="Path 5278"
                                        d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z"
                                        transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-linecap="round" stroke-width="1.5" />
                                      <path id="Path_5292" data-name="Path 5292"
                                        d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z"
                                        transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-linecap="round" stroke-width="1.5" />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div class="other-info flex-fill w-100">
                            <div class="other-name">
                              {{ item.from.user_name }}
                            </div>
                            <div>
                              <div class="d-inline-block">
                                <div class="message-info d-flex flex-column align-items-start">
                                  <div class="message-text" v-html="highlightedLink(item.message).message"></div>
                                  <div class="message-action d-flex justify-content-between align-items-center w-100">
                                    <span>{{
                                      formatDateTime(
                                        item.created,
                                        item.show_full_date
                                          ? 'DD/MM/YYYY HH:mm'
                                          : 'HH:mm'
                                      )
                                    }}</span>
                                    <span role="button" class="reply-action ml-2"
                                      @click="() => openReply(item)">Reply</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="item.files.length > 0" style="margin-top: 5px;">
                              <div class="d-inline-block">
                                <div class="message-box-album d-flex flex-wrap gap-4">
                                  <div v-for="_item in item.files" :key="_item._id"
                                    class="album-item flex-shrink-0 position-relative" role="button"
                                    data-fancybox="album" :data-src="_item.path" :data-type="item.files[0].type === 'video'
                                      ? 'html5video'
                                      : ''
                                      ">
                                    <img class="w-100 h-100" :src="_item.thumb" alt="Img" />
                                    <div v-if="item.files[0].type === 'video'"
                                      class="play-icon d-flex align-items-center justify-content-center"
                                      role="button">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff"
                                        viewBox="0 0 16 16">
                                        <path
                                          d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div class="d-inline-block timestamp-reply">
                                  <span class="timestamp">
                                    {{
                                      formatDateTime(
                                        item.created,
                                        item.show_full_date
                                          ? 'DD/MM/YYYY HH:mm'
                                          : 'HH:mm'
                                      )
                                    }}
                                  </span>
                                  <span v-if="item.files.length == 1" role="button" class="reply-action ml-2"
                                    @click="() => openReply(item, item.files[0].type)">Reply</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="
                      item.files.length > 0 && item.files[0].type === 'image'
                    " class="message-item message-item-other message-item-album"
                      :style="{ marginTop: item.message ? '-10px' : '0' }">
                      <div class="message-max-width">
                        <div class="d-flex justify-content-between">
                          <div class="thumb flex-shrink-0">
                            <img v-if="item.from.avatar" class="w-100 h-100" :src="item.from.avatar" alt="User" />
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40" class="w-100 h-100"
                              viewBox="0 0 120 120">
                              <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                                <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60"
                                  transform="translate(16 228)" fill="#2c2c2f" />
                                <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                                  <rect id="Rectangle_3421" data-name="Rectangle 3421" width="80" height="80"
                                    fill="rgba(255,255,255,0)" />
                                  <g id="Group_9146" data-name="Group 9146">
                                    <rect id="Rectangle_3421-2" data-name="Rectangle 3421" width="80" height="80"
                                      fill="rgba(255,255,255,0)" />
                                    <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                                      <circle id="Ellipse_4" data-name="Ellipse 4" cx="15.439" cy="15.439" r="15.439"
                                        transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-width="1.5" />
                                      <path id="Path_5278" data-name="Path 5278"
                                        d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z"
                                        transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-linecap="round" stroke-width="1.5" />
                                      <path id="Path_5292" data-name="Path 5292"
                                        d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z"
                                        transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-linecap="round" stroke-width="1.5" />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div class="other-info flex-fill w-100">
                            <div class="other-name">
                              {{ item.from.user_name }}
                            </div>
                            <div class="message-box-album d-flex flex-wrap gap-4">
                              <div v-for="_item in item.files" :key="_item._id" class="album-item flex-shrink-0"
                                role="button" data-fancybox="album" :data-src="_item.path">
                                <img class="w-100 h-100" :src="_item.thumb" alt="Img" />
                              </div>
                            </div>
                            <div class="d-inline-block timestamp-reply">
                              <span class="timestamp">
                                {{
                                  formatDateTime(
                                    item.created,
                                    item.show_full_date
                                      ? 'DD/MM/YYYY HH: mm'
                                      : 'HH: mm'
                                  )
                                }}
                              </span>
                              <span v-if="item.files.length == 1" role="button" class="reply-action ml-2"
                                @click="() => openReply(item, 'image')">Reply</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="
                      item.files.length > 0 && item.files[0].type === 'video'
                    " class="message-item message-item-other message-item-album"
                      :style="{ marginTop: item.message ? '-10px' : '0' }">
                      <div class="message-max-width">
                        <div class="d-flex justify-content-between">
                          <div class="thumb flex-shrink-0">
                            <img v-if="item.from.avatar" class="w-100 h-100" :src="item.from.avatar" alt="User" />
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="40" height="40" class="w-100 h-100"
                              viewBox="0 0 120 120">
                              <g id="ic_avatar_default_120" transform="translate(-16 -228)">
                                <circle id="Ellipse_103" data-name="Ellipse 103" cx="60" cy="60" r="60"
                                  transform="translate(16 228)" fill="#2c2c2f" />
                                <g id="Group_5173" data-name="Group 5173" transform="translate(36 248)">
                                  <rect id="Rectangle_3421" data-name="Rectangle 3421" width="80" height="80"
                                    fill="rgba(255,255,255,0)" />
                                  <g id="Group_9146" data-name="Group 9146">
                                    <rect id="Rectangle_3421-2" data-name="Rectangle 3421" width="80" height="80"
                                      fill="rgba(255,255,255,0)" />
                                    <g id="user-rounded-svgrepo-com" transform="translate(13.333 3.333)">
                                      <circle id="Ellipse_4" data-name="Ellipse 4" cx="15.439" cy="15.439" r="15.439"
                                        transform="translate(11.579 0)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-width="1.5" />
                                      <path id="Path_5278" data-name="Path 5278"
                                        d="M32.018,43.877C17.1,43.877,5,36.965,5,28.439S17.1,13,32.018,13,36.161,43.877,32.018,43.877Z"
                                        transform="translate(-5 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-linecap="round" stroke-width="1.5" />
                                      <path id="Path_5292" data-name="Path 5292"
                                        d="M12.652,43.877c14.921,0,27.018-6.912,27.018-15.439S27.573,13,12.652,13,8.508,43.877,12.652,43.877Z"
                                        transform="translate(11.667 29.456)" fill="#4d4d4d" stroke="#4d4d4d"
                                        stroke-linecap="round" stroke-width="1.5" />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div class="other-info flex-fill w-100">
                            <div class="other-name">
                              {{ item.from.user_name }}
                            </div>
                            <div class="message-box-album d-flex flex-wrap gap-4">
                              <div v-for="_item in item.files" :key="_item._id"
                                class="album-item flex-shrink-0 position-relative" role="button" data-fancybox="album"
                                :data-src="_item.path" data-type="html5video">
                                <img class="w-100 h-100" :src="_item.thumb" alt="Img" />
                                <div class="play-icon d-flex align-items-center justify-content-center" role="button">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff"
                                    viewBox="0 0 16 16">
                                    <path
                                      d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div class="d-inline-block timestamp-reply">
                              <span class="timestamp">
                                {{
                                  formatDateTime(
                                    item.created,
                                    item.show_full_date
                                      ? 'DD/MM/YYYY HH: mm'
                                      : 'HH: mm'
                                  )
                                }}
                              </span>
                              <span v-if="item.files.length == 1" role="button" class="reply-action ml-2"
                                @click="() => openReply(item, 'video')">Reply</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </div>
          </div>
          <button v-if="isScrollBottom" @click="scrollToEndChat" :class="[
            'scroll-end-bottom position-absolute right-0',
            isScrollBottom ? 'show' : 'hide',
          ]">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path fill="currentColor" d="M12 5v12.25L17.25 12l.75.66l-6.5 6.5l-6.5-6.5l.75-.66L11 17.25V5z" />
            </svg>
          </button>
          <div :class="[
            'content-footer d-flex flex-shink-0 position-relative',
            isExpanded ? 'align-items-end h-auto' : 'align-items-center',
          ]">
            <div v-if="isSendMessage" class="isLoading">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#666666"
                  class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
                  <path
                    d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </span>
            </div>
            <div v-if="
              (isBoxImage && fileImagePreview.length > 0) ||
              (isBoxVideo && fileVideoPreview.length > 0)
            " class="options w-100">
              <span class="icon-close" @click="() => closeBoxFile(isBoxImage ? 'image' : 'video')"
                role="button">x</span>
              <div class="images" v-if="isBoxImage && fileImagePreview.length > 0">
                <h5>{{ fileImagePreview.length }} images</h5>
                <div class="image-container d-flex">
                  <div v-for="(item, index) in fileImagePreview" :key="index"
                    class="image-item flex-shrink-0 position-relative">
                    <img :src="item" />
                    <div @click="removeFileItem(index, 'image')" role="button">
                      x
                    </div>
                  </div>
                </div>
              </div>
              <div class="videos" v-if="isBoxVideo && fileVideoPreview.length > 0">
                <h5>{{ fileVideoPreview.length }} videos</h5>
                <div class="video-container d-flex">
                  <div v-for="(item, index) in fileVideoPreview" :key="index"
                    class="video-item flex-shrink-0 position-relative">
                    <img :src="item" />
                    <div @click="removeFileItem(index, 'video')" role="button">
                      x
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isBoxReply && replyItem" class="reply-box-chat">
              <div class="position-relative d-flex align-items-center justify-content-between">
                <div v-if="replyItem.reply_type !== 'text'"
                  class="reply-thumb d-flex align-items-center justify-content-center flex-shrink-0">
                  <svg v-if="replyItem.reply_type === 'pdf'" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" fill="#FAE0A0" width="16" height="16"
                    viewBox="0 0 256 256" xml:space="preserve">
                    <defs></defs>
                    <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                      <path
                        d="M 77.474 17.28 L 61.526 1.332 C 60.668 0.473 59.525 0 58.311 0 H 15.742 c -2.508 0 -4.548 2.04 -4.548 4.548 v 80.904 c 0 2.508 2.04 4.548 4.548 4.548 h 58.516 c 2.508 0 4.549 -2.04 4.549 -4.548 V 20.496 C 78.807 19.281 78.333 18.138 77.474 17.28 z M 61.073 5.121 l 12.611 12.612 H 62.35 c -0.704 0 -1.276 -0.573 -1.276 -1.277 V 5.121 z M 74.258 87 H 15.742 c -0.854 0 -1.548 -0.694 -1.548 -1.548 V 4.548 C 14.194 3.694 14.888 3 15.742 3 h 42.332 v 13.456 c 0 2.358 1.918 4.277 4.276 4.277 h 13.457 v 64.719 C 75.807 86.306 75.112 87 74.258 87 z"
                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                      <path
                        d="M 26.806 75.278 c -1.29 0 -2.11 -0.732 -2.473 -1.15 l -0.14 -0.162 l -0.089 -0.193 c -0.854 -1.853 -1.232 -4.745 1.809 -8.01 c 2.483 -2.666 6.624 -4.957 11.318 -6.697 c 1.585 -2.964 3.067 -6.128 4.265 -9.157 c -2.997 -4.992 -4.234 -10.248 -2.971 -13.719 c 0.709 -1.948 2.179 -3.174 4.14 -3.452 l 0.211 -0.015 c 2.147 0 3.689 1.282 4.232 3.516 c 0.729 3.003 -0.306 7.954 -2.271 13.335 c 0.745 1.108 1.601 2.216 2.567 3.293 c 0.912 1.101 1.842 2.1 2.771 2.999 c 5.057 -0.67 9.654 -0.562 12.521 0.52 c 3.231 1.219 3.771 3.396 3.804 4.586 l 0.001 0.03 c 0.016 1.91 -0.942 3.359 -2.63 3.976 c -3.511 1.286 -9.379 -1.229 -14.678 -5.943 c -3.251 0.526 -6.669 1.374 -9.849 2.472 c -3.526 6.359 -7.529 11.694 -10.478 13.216 C 28.081 75.126 27.395 75.278 26.806 75.278 z M 26.714 72.252 c 0.112 0.046 0.321 0.038 0.776 -0.197 c 1.955 -1.009 4.643 -4.384 7.299 -8.718 c -2.787 1.308 -5.143 2.82 -6.681 4.471 C 26.094 69.97 26.427 71.524 26.714 72.252 z M 53.291 58.535 c 4.155 3.122 7.893 4.232 9.55 3.624 c 0.321 -0.117 0.662 -0.31 0.659 -1.119 c -0.01 -0.333 -0.063 -1.169 -1.864 -1.849 C 59.685 58.454 56.703 58.272 53.291 58.535 z M 43.53 52.896 c -0.677 1.611 -1.421 3.235 -2.208 4.829 c 1.733 -0.499 3.498 -0.924 5.243 -1.266 c -0.488 -0.526 -0.967 -1.072 -1.432 -1.634 C 44.57 54.198 44.035 53.553 43.53 52.896 z M 42.982 35.724 c -0.531 0.094 -1.232 0.375 -1.639 1.492 c -0.705 1.937 -0.214 5.265 1.519 8.907 c 1.234 -3.82 1.822 -7.146 1.329 -9.176 C 43.936 35.892 43.479 35.739 42.982 35.724 z"
                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                    </g>
                  </svg>
                  <img v-else-if="replyItem.reply_type === 'image'" class="w-100 h-100" :src="replyItem.files[0].path"
                    alt="" />
                  <img v-else-if="replyItem.reply_type === 'video'" class="w-100 h-100"
                    :src="replyItem.files[0].thumb" alt="" />
                </div>
                <div class="flex-fill w-100">
                  <div class="reply-title">
                    {{
                      replyItem.from._id == userLogin.uid
                        ? 'You'
                        : replyItem.from.user_name
                    }}
                  </div>
                  <div class="reply-desc text-truncate">
                    {{ getTextReply(replyItem) }}
                  </div>
                </div>
              </div>
              <span class="icon-close" @click="closeReply" role="button">x</span>
            </div>
            <ul class="action-button d-flex align-items-center">
              <li class="position-relative">
                <label for="upload-image" class="cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g id="ic_add_img_24dp" data-name="ic_add img_24dp" transform="translate(-840 -1004)">
                      <rect id="Rectangle_9122" data-name="Rectangle 9122" width="24" height="24"
                        transform="translate(840 1004)" fill="none" />
                      <path id="Path_9819" data-name="Path 9819"
                        d="M17.579,4.25H5.921A2.671,2.671,0,0,0,3.25,6.921v9.714a2.671,2.671,0,0,0,2.671,2.671H17.579a2.671,2.671,0,0,0,2.671-2.671V6.921A2.671,2.671,0,0,0,17.579,4.25ZM5.921,5.707H17.579a1.214,1.214,0,0,1,1.214,1.214v7.956l-2.642-2.642a.68.68,0,0,0-.544-.214.767.767,0,0,0-.534.262l-1.253,1.506L9.351,9.321a.68.68,0,0,0-.515-.214.767.767,0,0,0-.534.262L4.707,13.653V6.921A1.214,1.214,0,0,1,5.921,5.707ZM4.707,16.636v-.709l4.177-5.013,4,4-2.448,2.914H5.921a1.214,1.214,0,0,1-1.214-1.2ZM17.579,17.85H12.333l3.351-4.022,3.06,3.06a1.2,1.2,0,0,1-1.166.962Z"
                        transform="translate(840 1004)" />
                    </g>
                  </svg>
                </label>
                <input id="upload-image" :disabled="disabledActionInput" multiple accept="image/*" type="file"
                  @change="(event) => onFileChange(event, 'image')" />
              </li>
              <li class="position-relative">
                <label for="upload-video" class="cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g id="ic_add_video_24dp" data-name="ic_add video_24dp" transform="translate(-844 -1008)">
                      <rect id="Rectangle_9122" data-name="Rectangle 9122" width="24" height="24"
                        transform="translate(844 1008)" fill="none" />
                      <g id="video" transform="translate(844 1008)">
                        <path id="Path_9855" data-name="Path 9855"
                          d="M13.39,19.136H6.11a2.844,2.844,0,0,1-2.86-2.829V8.079A2.844,2.844,0,0,1,6.11,5.25h7.28a2.844,2.844,0,0,1,2.86,2.829v8.229a2.844,2.844,0,0,1-2.86,2.829ZM6.11,6.793a1.293,1.293,0,0,0-1.3,1.286v8.229a1.293,1.293,0,0,0,1.3,1.286h7.28a1.293,1.293,0,0,0,1.3-1.286V8.079a1.293,1.293,0,0,0-1.3-1.286Z" />
                        <path id="Path_9856" data-name="Path 9856"
                          d="M20,17.136a.767.767,0,0,1-.39-.114l-5-3.122a.788.788,0,0,1-.36-.666V11.152a.788.788,0,0,1,.36-.666l5-3.122a.715.715,0,0,1,.76,0,.786.786,0,0,1,.38.676v8.325a.786.786,0,0,1-.38.676.688.688,0,0,1-.37.094ZM15.75,12.8l3.5,2.185V9.4l-3.5,2.185Z"
                          transform="translate(0.5 0)" />
                      </g>
                    </g>
                  </svg>
                </label>
                <input id="upload-video" :disabled="disabledActionInput" multiple accept="video/*" type="file"
                  @change="(event) => onFileChange(event, 'video')" />
              </li>
              <li class="position-relative">
                <label for="upload-pdf" class="cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g id="ic_add_file_24dp" data-name="ic_add file_24dp" transform="translate(-844 -1008)">
                      <rect id="Rectangle_9122" data-name="Rectangle 9122" width="24" height="24"
                        transform="translate(844 1008)" fill="none" />
                      <g id="file-pdf" transform="translate(844.75 1007.75)">
                        <path id="Path_9857" data-name="Path 9857"
                          d="M18.53,9,13,3.47a.75.75,0,0,0-.53-.22H8A2.75,2.75,0,0,0,5.25,6V18A2.75,2.75,0,0,0,8,20.75h8A2.75,2.75,0,0,0,18.75,18V9.5a.75.75,0,0,0-.22-.5ZM13.25,5.81l2.94,2.94H13.25ZM16,19.25H8A1.25,1.25,0,0,1,6.75,18V6A1.25,1.25,0,0,1,8,4.75h3.75V9.5a.76.76,0,0,0,.75.75h4.75V18A1.25,1.25,0,0,1,16,19.25Z" />
                        <path id="Path_9858" data-name="Path 9858"
                          d="M13.49,14.85a3.15,3.15,0,0,1-1.31-1.66,4.44,4.44,0,0,0,.19-2A.8.8,0,0,0,10.85,11a5,5,0,0,0,.25,2.4q-.57,1.331-1.27,2.6c-.71.4-1.68,1-1.83,1.69-.12.56.93,2,2.72-1.12a18.58,18.58,0,0,1,2.44-.72,4.72,4.72,0,0,0,2,.61.82.82,0,0,0,.62-1.38C15.36,14.65,14.11,14.77,13.49,14.85Zm-4.78,3A4.32,4.32,0,0,1,9.8,16.61c-.68,1.08-1.09,1.27-1.09,1.25Zm2.92-6.81c.26,0,.24,1.15.06,1.46a3.07,3.07,0,0,1-.06-1.45Zm-.87,4.88A14.76,14.76,0,0,0,11.64,14a3.88,3.88,0,0,0,1.08,1.26,12.35,12.35,0,0,0-1.96.67Zm4.7-.18s-.18.22-1.33-.28c1.25-.08,1.46.21,1.33.29Z" />
                      </g>
                    </g>
                  </svg>
                </label>
                <input id="upload-pdf" :disabled="disabledActionInput" accept="application/pdf" type="file"
                  @change="(event) => onFileChange(event, 'pdf')" />
              </li>
            </ul>
             <!-- @keydown.enter.prevent="sendMessage" -->
            <textarea id="chat-input" @keydown="handleChatKeydown" ref="chatInputRef"
              v-model="formData.message" class="w-100" @input="autoResize" type="text"
              placeholder="Write a message..." ></textarea>
            <button v-if="isSendMessage" id="send" class="flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.524" height="17.481" viewBox="0 0 17.524 17.481">
                <g id="ic_send" transform="translate(-3.225 -3.249)">
                  <path id="Path_9823" data-name="Path 9823"
                    d="M20.33,3.67a1.45,1.45,0,0,0-1.47-.35L4.23,8.2A1.44,1.44,0,0,0,4,10.85l6.07,3,3,6.09a1.44,1.44,0,0,0,1.29.79h.1a1.43,1.43,0,0,0,1.26-1L20.67,5.14A1.41,1.41,0,0,0,20.33,3.67ZM4.85,9.58,17.62,5.32l-7.09,7.09Zm9.58,9.57-2.84-5.68,7.09-7.09Z" />
                </g>
              </svg>
            </button>
            <button v-else @click="sendMessage" id="send" class="flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.524" height="17.481" viewBox="0 0 17.524 17.481">
                <g id="ic_send" transform="translate(-3.225 -3.249)">
                  <path id="Path_9823" data-name="Path 9823"
                    d="M20.33,3.67a1.45,1.45,0,0,0-1.47-.35L4.23,8.2A1.44,1.44,0,0,0,4,10.85l6.07,3,3,6.09a1.44,1.44,0,0,0,1.29.79h.1a1.43,1.43,0,0,0,1.26-1L20.67,5.14A1.41,1.41,0,0,0,20.33,3.67ZM4.85,9.58,17.62,5.32l-7.09,7.09Zm9.58,9.57-2.84-5.68,7.09-7.09Z" />
                </g>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <video ref="videoRef" style="display:none"></video>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { Fancybox } from '@fancyapps/ui';

import moment from 'moment-timezone';
import axios from 'axios';
import Dialog from 'primevue/dialog';
import ApiRepository from '@/core/ApiRepository';
//import DataServices from '@/core/DataServices'

const ALLOWED_FILE_TYPES = ['image/png', 'image/jpeg', 'image/jpg'];
const MAX_FILE_SIZE = 50 * 1024 * 1024;

export default {
  components: {
     Dialog,
     
  },
  data() {
    return {
      maxFileUpload: 5,
      time_zone_local: moment.tz.guess(true),
      domain: this.$ConfigEvn.chat_url,
      clientDomain: this.$ConfigEvn.website_url,
      userLogin: localStorage.getItem('state_login')
        ? JSON.parse(localStorage.getItem('state_login'))
        : null,
      old_message: [],
      list_message: [],
      isExpanded: false,
      isBoxImage: false,
      isBoxVideo: false,
      fileVideos: [],
      fileVideoPreview: [],
      fileImages: [],
      fileImagePreview: [],
      formData: {
        message: '',
        conversation_id: '',
        type: 'text',
        file_ids: [],
        payload: '',
        reply_id: '',
      },
      keyword: '',
      list_conversation: {
        offset: 0,
        conversations: [],
        limit: this.limit,
      },
      conversation_active: null,
      limit: 20,
      isPrev: true,
      isNext: true,
      isNextConversation: true,
      isLoadConversation: false,
      isLoadMore: false,
      isScrollBottom: false,
      replyItem: false,
      isBoxReply: false,
      isShowUnreadMessage: false,
      timeCount: null,
      keyClass: 'message-item-container',
      disabledActionInput: false,
      isSendMessage: false,
      rentalTotal: 0,
      showCustomerInfo: false,
      currentUserId:null,

      showFilterPanel: false,
selectedTagFilters: [],

      // TAGS
  showTagDialog: false,
  tagSelectedToAdd: [],
  tagMaster: [
  { "key": "#Interested#", "value": "Interested", "color": "#1E90FF", "text_color": "#FFFFFF" },
  { "key": "#Information_Received#", "value": "Information Received", "color": "#7B61FF", "text_color": "#FFFFFF" },
  { "key": "#Consulting#", "value": "Consulting", "color": "#FF9F43", "text_color": "#FFFFFF" },
  { "key": "#Deposit_Paid#", "value": "Deposit Paid", "color": "#2ECC71", "text_color": "#FFFFFF" },
  { "key": "#Vehicle_Received#", "value": "Vehicle Received", "color": "#20C997", "text_color": "#FFFFFF" },
  { "key": "#Issue#", "value": "Issue", "color": "#FF4D4F", "text_color": "#FFFFFF" },
  { "key": "#Handing#", "value": "Handing", "color": "#FA541C", "text_color": "#FFFFFF" },
  { "key": "#Done#", "value": "Done", "color": "#52C41A", "text_color": "#FFFFFF" },
  { "key": "#Accident#", "value": "Accident", "color": "#A8071A", "text_color": "#FFFFFF" },
  { "key": "#Spam#", "value": "Spam", "color": "#BFBFBF", "text_color": "#000000" }
]
,//

    isSavingTags: false,
  icon_add_tag:require("@/assets/add_tag_icon.png"),
  Icon_filter:require("@/assets/Icon_filter.png"),
    };
  },
  
  mounted() {
    this.initChat();
    Fancybox.bind('[data-fancybox]');
  },

  watch: {
    'conversation_active.unread'() {
      this.countTimeToUpdateMessageRead();
    },
  },
computed: {
  availableTagOptions() {
    const currentKeys = new Set((this.conversation_active?.tags || []).map(t => String(t?.key)));
    return (this.tagMaster || [])
      .filter(t => t?.key && !currentKeys.has(String(t.key)))
      .map(t => ({ key: t.key, value: t.value })); // MultiSelect options
  },
  availableTags() {
  const set = new Set();
  (this.list_conversation?.conversations || []).forEach(c => {
    const tags = this.getConversationTags(c) || [];
    tags.forEach(t => set.add(t));
  });
  return Array.from(set);
},
isFiltering() {
    return Array.isArray(this.selectedTagFilters) && this.selectedTagFilters.length > 0;
  }

},

  methods: {
  handleChatKeydown(e) {
  if (e.key !== 'Enter') return;

  // IME
  if (e.isComposing || e.keyCode === 229) return;

  // Alt + Enter => chèn '\n' thủ công
  if (e.altKey) {
    e.preventDefault();

    const el = this.$refs.chatInputRef;
    const start = el.selectionStart ?? this.formData.message.length;
    const end = el.selectionEnd ?? this.formData.message.length;

    const text = this.formData.message || '';
    this.formData.message = text.slice(0, start) + '\n' + text.slice(end);

    this.$nextTick(() => {
      // đặt caret sau newline
      el.selectionStart = el.selectionEnd = start + 1;
      this.autoResize();
    });
    return;
  }

  // Enter => submit
  e.preventDefault();
  this.sendMessage();
},


    toggleFilterPanel() {
  this.showFilterPanel = !this.showFilterPanel;
},

clearTagFilters() {
  this.selectedTagFilters = [];
  this.reloadConversationListByFilter();
},

applyTagFilters() {
  this.showFilterPanel = false;
  this.reloadConversationListByFilter();
},
emit_conversation_list(offset=0,limit) {
const tag_str = (this.selectedTagFilters || [])
  .map(t => typeof t === "string" ? t : t.key )
  .join(",");
   console.log("tag_strtag_strtag_str",tag_str);
  this.$store.state.socket.emit("conversation:list", {
    offset: offset,
    limit: limit,
    keyword: this.keyword || "",
    str_tag_filter: tag_str,
  });
},
reloadConversationListByFilter() {
  // reset paging để list tải lại từ đầu
  this.list_conversation.offset = 0;
  this.isNextConversation = true;
  this.isLoadConversation = false;
 this.emit_conversation_list(0,this.limit)
},

   getParsedTags(tagStr) {
    if (!tagStr) return []

    const tags = tagStr.split(',')

    return this.tagMaster.filter(tag =>
      tags.includes(tag.key)
    )
  },
  // Unified tag loader for both left menu and conversation_active
  getConversationTags(conversation) {
    if (!conversation) return [];
    // Prefer normalized `conversation.tags` if present
    if (Array.isArray(conversation.tags) && conversation.tags.length > 0) return conversation.tags;

    // Fallback: parse from user's stored tag_str (legacy/back-end field)
    const tagStr = conversation?.tag_str;
    const parsed = this.getParsedTags(tagStr);

    // Cache normalized tags so subsequent renders use same logic
    if (parsed.length > 0) this.$set(conversation, 'tags', parsed);
    return parsed;
  },

  syncConversationTagStr(conversation, tagObjects = []) {
    if (!conversation) return;
    const keys = (tagObjects || []).map(t => String(t.key)).filter(Boolean);
    // if (conversation.users && conversation.users.length > 0) {
    //   this.$set(conversation.users[0], 'tag_str', keys.join(','));
    // }
    this.$set(conversation, 'tag_str', keys.join(','));
  },

      async saveConversationTagKeys(conversationId, keys) {
  // save tags by socket (no API)
  const socket = this.$store.state.socket;
  const tag_str = (keys || []).map(String).join(",");

  if (!socket || !socket.connected) {
    throw new Error("Socket not connected");
  }

  // wait server broadcast conversation:update
  await new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      socket.off("conversation:update", onUpdated);
      reject(new Error("Update tag timeout"));
    }, 3000);

    const onUpdated = (conversation) => {
      if (conversation && String(conversation._id) === String(conversationId)) {
        clearTimeout(timer);
        socket.off("conversation:update", onUpdated);
        resolve(conversation);
      }
    };

    socket.on("conversation:update", onUpdated);
    socket.emit("conversation:update", { conversation_id: conversationId, tag_str });
  });
},



    buildTagObjectsFromKeys(keys = []) {
    const map = new Map((this.tagMaster || []).map(t => [String(t.key), t]));
    return keys
      .map(k => map.get(String(k)))
      .filter(Boolean);
  },
     openTagDialog() {
    this.tagSelectedToAdd = [];
    this.showTagDialog = true;
  },
  closeTagDialog() {
    this.showTagDialog = false;
    this.tagSelectedToAdd = [];
  },

  async confirmAddTags() {
    if (!this.conversation_active) return;

    const current = Array.isArray(this.conversation_active.tags) ? [...this.conversation_active.tags] : [];
    const currentKeys = new Set(current.map(t => String(t.key)));

    // keys selected from MultiSelect
    const selectedKeys = (this.tagSelectedToAdd || []).map(String);
    const newKeys = selectedKeys.filter(k => !currentKeys.has(k));

    if (newKeys.length === 0) {
      this.closeTagDialog();
      return;
    }

    const toAddObjects = this.buildTagObjectsFromKeys(newKeys);
    const next = [...current, ...toAddObjects];

    // optimistic UI update
    const prev = current;
    this.$set(this.conversation_active, 'tags', next);

    const idx = (this.list_conversation?.conversations || []).findIndex(
      c => c._id === this.conversation_active._id
    );
    if (idx !== -1) this.$set(this.list_conversation.conversations[idx], 'tags', next);

    // keep legacy tag_str in sync (used by backend / other screens)
    this.syncConversationTagStr(this.conversation_active, next);
    if (idx !== -1) this.syncConversationTagStr(this.list_conversation.conversations[idx], next);
    // keep legacy tag_str in sync (used by backend / other screens)
    this.syncConversationTagStr(this.conversation_active, next);
    if (idx !== -1) this.syncConversationTagStr(this.list_conversation.conversations[idx], next);
    console.log("this.list_conversation.conversations:",this.list_conversation.conversations[idx].tags)

    this.isSavingTags = true;
    try {
      const keysToSave = next.map(t => String(t.key));
      await this.saveConversationTagKeys(this.conversation_active._id, keysToSave);

      this.closeTagDialog();
    } catch (e) {
      console.log("eeeee:",e)
      // rollback
      this.$set(this.conversation_active, 'tags', prev);
      if (idx !== -1) this.$set(this.list_conversation.conversations[idx], 'tags', prev);
      this.syncConversationTagStr(this.conversation_active, prev);
      if (idx !== -1) this.syncConversationTagStr(this.list_conversation.conversations[idx], prev);
      const msg = e?.response?.data?.message || 'Save tags failed. Please try again.';
      alert(msg);
    } finally {
      this.isSavingTags = false;
    }
  },
  async removeTag(tagKey) {
    if (!this.conversation_active || !Array.isArray(this.conversation_active.tags)) return;

    const prev = [...this.conversation_active.tags];
    const next = prev.filter(t => String(t.key) !== String(tagKey));

    // optimistic UI update
    this.$set(this.conversation_active, 'tags', next);

    const idx = (this.list_conversation?.conversations || []).findIndex(
      c => c._id === this.conversation_active._id
    );
    if (idx !== -1) this.$set(this.list_conversation.conversations[idx], 'tags', next);

    // keep legacy tag_str in sync (used by backend / other screens)
    this.syncConversationTagStr(this.conversation_active, next);
    if (idx !== -1) this.syncConversationTagStr(this.list_conversation.conversations[idx], next);

    this.isSavingTags = true;
    try {
      const keysToSave = next.map(t => String(t.key));
await this.saveConversationTagKeys(this.conversation_active._id, keysToSave);

    } catch (e) {
      // rollback
      this.$set(this.conversation_active, 'tags', prev);
      if (idx !== -1) this.$set(this.list_conversation.conversations[idx], 'tags', prev);
      this.syncConversationTagStr(this.conversation_active, prev);
      if (idx !== -1) this.syncConversationTagStr(this.list_conversation.conversations[idx], prev);

      const msg = e?.response?.data?.message || 'Remove tag failed. Please try again.';
      alert(msg);
    } finally {
      this.isSavingTags = false;
    }
  },


    formatDateTime(date, format) {
      return moment.tz(date, this.time_zone_local).format(format);
    },

    formatDateLabel(date) {
      const messageDate = moment(date).tz(this.time_zone_local);

      if (messageDate.isSame(moment().tz(this.time_zone_local), 'day')) {
        return {
          text: 'Today',
          isDate: false,
        };
      }
      return {
        text: messageDate.format('DD/MM/YYYY'),
        isDate: true,
      };
    },

    openBoxFile(type) {
      if (type == 'image') {
        this.isBoxImage = true;
      } else {
        this.isBoxVideo = true;
      }
    },

    closeBoxFile(type) {
      if (type == 'image') {
        this.isBoxImage = false;
        this.fileImages = [];
        this.fileImagePreview = [];
      } else if (type == 'video') {
        this.isBoxVideo = false;
        this.fileVideos = [];
        this.fileVideoPreview = [];
      } else {
        this.isBoxImage = false;
        this.fileImages = [];
        this.fileImagePreview = [];
        this.isBoxVideo = false;
        this.fileVideos = [];
        this.fileVideoPreview = [];
      }
    },

    handleInput(event) {
      const newKeyword = event.target.value;
      this.keyword = newKeyword;
      this.onSearch();
    },

    onSearch() {
      this.list_conversation.conversations = [];
      this.list_conversation.offset = 0;
      this.isNextConversation = true;
      this.isLoadConversation = false;

      
       this.emit_conversation_list(0,this.limit)
    },

    scrollToEndChat() {
      const chatContentRef = this.$refs.chatContentRef;
      if (chatContentRef) {
        chatContentRef.scroll({
          top: chatContentRef.scrollHeight,
          behavior: 'smooth',
        });
      }
    },

    openReply(messageItem, type = 'text') {
      if (type === 'image') {
        messageItem.reply_type = 'image'
      } else if (type === 'video') {
        messageItem.reply_type = 'video'
      } else if (type === 'pdf') {
        messageItem.reply_type = 'pdf'
      } else {
        messageItem.reply_type = 'text'
      }

      this.isBoxReply = true;
      this.replyItem = messageItem;
      this.formData.type = 'text';
      this.formData.reply_id = messageItem._id;
      this.closeBoxFile('*');
      this.disabledActionInput = true;
      this.$refs.chatInputRef.focus();
    },

    getTextReply(item) {
      if (item.reply_type === 'image') {
        return '[Image]'
      } else if (item.reply_type === 'video') {
        return '[Video]'
      } else if (item.reply_type === 'pdf') {
        return this.getFileNameFromPath(item.files[0].path || '')
      } else {
        return item.message
      }
    },

    scrollToElement(element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      element.classList.add('highlighted')
      setTimeout(() => {
        element.classList.remove('highlighted')
      }, 1000)
      return
    },

    async onMoveToReply(message_id) {
      const targetId = `${this.keyClass}___${message_id}`;
      let targetElement = document.getElementById(targetId);

      if (targetElement) {
        this.scrollToElement(targetElement)
        return
      }

      while (!targetElement && this.conversation_active) {
        await this.loadPreviousMessages();
        await this.$nextTick();
        const newTargetElement = document.getElementById(targetId);
        if (newTargetElement) {
          this.scrollToElement(newTargetElement)
          break
        }
      }
    },

    closeReply() {
      this.isBoxReply = false;
      this.replyItem = null;
      this.formData.reply_id = '';
      this.disabledActionInput = false;
    },

    autoResize() {
      const inputRef = this.$refs.chatInputRef;
      if (this.formData.message.trim() === '') {
        inputRef.style.height = '32px';
        this.isExpanded = false;
      } else {
        inputRef.style.height = `${Math.min(inputRef.scrollHeight, 85)}px`;
        this.isExpanded = inputRef.scrollHeight > 50;
      }
    },

    async changeConversation(conversation) {
      this.conversation_active = conversation;
      // Normalize tags so left menu & active conversation share the same logic/source of truth
      if (this.conversation_active) {
        const normalized = this.getConversationTags(this.conversation_active);
        this.$set(this.conversation_active, 'tags', normalized);
      }
      // Reset
      this.old_message = [];
      this.list_message = [];
      this.isExpanded = false;
      this.isBoxImage = false;
      this.isBoxVideo = false;
      this.fileVideos = [];
      this.fileVideoPreview = [];
      this.fileImages = [];
      this.fileImagePreview = [];
      this.formData = {
        message: '',
        conversation_id: conversation?._id || '',
        type: 'text',
        file_ids: [],
        payload: '',
        reply_id: '',
      };
      // this.keyword = '';
      this.isPrev = true;
      this.isNext = true;
      this.isLoadMore = false;
      this.isLoadConversation = false;
      this.isScrollBottom = false;
      this.replyItem = false;
      this.isBoxReply = false;
      this.isShowUnreadMessage = false;
      this.timeCount = null;
      this.disabledActionInput = false;
      this.isSendMessage = false;

      if (conversation) {
        this.$store.state.socket.emit('conversation:join', {
          conversation_id: conversation._id,
          loadLastMessage: true,
        });

        this.$store.state.socket.timeout(1000).emit('message:list', {
          conversation_id: conversation._id,
          message_id: conversation.last_message
            ? conversation.last_message._id
            : null,
          type: 'initial',
        });

        const userId = conversation.users[0]._id;
        this.currentUserId = userId;
        console.log("userIduserId:",this.currentUserId);
        console.log("conversation._id:",conversation._id);
        const GET_USER_TOTAL_ORDER_RENT = gql`
          query GetUserTotalOrderRent($userId: uuid!) {
            users(where: { id: { _eq: $userId } }) {
              total_order_rent
              total_order_buy
              total_order_sell
            }
          }
        `;
        const { data } = await this.$apollo.query({
          query: GET_USER_TOTAL_ORDER_RENT,
          variables: {
            userId: userId,
          },
          fetchPolicy: 'network-only',
        });
        if (data.users && data.users.length > 0) {
          this.rentalTotal = data.users[0].total_order_rent + data.users[0].total_order_buy + data.users[0].total_order_sell;
        } else {
          this.rentalTotal = 0;
        }
      }

      // this.onSearch();
    },

    async sendMessage() {
      if (!navigator.onLine) {
        alert('Unable to send message, check network connection')
        setTimeout(() => {
          this.changeConversation(null)
        }, 1000)
        return
      }

      if (this.isSendMessage) return;
      if (
        this.formData.message.trim() === '' &&
        this.fileImages.length == 0 &&
        this.fileVideos.length == 0
      ) {
        this.$refs.chatInputRef.focus();
        return;
      }

      const textarea = this.$refs.chatInputRef;
      textarea.style.height = '40px';

      this.isSendMessage = true;
      this.isExpanded = false;
      this.isBoxImage = false;
      this.isBoxVideo = false;
      this.isBoxReply = false;

      if (this.formData.type == 'media') {
        try {
          if (this.fileImages.length > 0) {
            for (let index = 0; index < this.fileImages.length; index++) {
              if (index % 5 == 0) {
                await this.$commonFuction.sleep(100);
              }

              const image = this.fileImages[index];
              let form = new FormData();
              form.append('image', image.image);
              form.append('thumb', image.thumbnail);

              try {
                const response = await ApiRepository.post(
                  `${this.domain}/api/upload/image`,
                  form,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                      'App-type': 'admin',
                      Authorization: 'Bearer ' + this.userLogin.token,
                    },
                  }
                );
                this.formData.file_ids.push(response.data.data._id);
              } catch (error) {
                var message = error?.response?.data?.message || '';
                console.error('There was an error!', message);
                switch (message) {
                  case 'INVALID_TOKEN_ERR':
                    alert(this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN);
                    location.reload();
                    break;
                  default:
                    alert(this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN);
                }
              }
            }
          } else if (this.fileVideos.length > 0) {
            for (let index = 0; index < this.fileVideos.length; index++) {
              if (index % 5 == 0) {
                await this.$commonFuction.sleep(100);
              }

              const video = this.fileVideos[index];
              let form = new FormData();
              form.append('video', video.video);
              form.append('thumb', video.thumbnail);

              try {
                const response = await ApiRepository.post(
                  `${this.domain}/api/upload/video`,
                  form,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                      'App-type': 'admin',
                      Authorization: 'Bearer ' + this.userLogin.token,
                    },
                  }
                );

                this.formData.file_ids.push(response.data.data._id);
              } catch (error) {
                console.error('error: ', error);
                const message = error?.response?.data?.message || '';
                switch (message) {
                  case 'INVALID_TOKEN_ERR':
                    alert(this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN);
                    location.reload();
                    break;
                  default:
                    alert(this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN);
                }
              }
            }
          }
          this.$store.state.socket.timeout(1000).emit('message:send', this.formData);
          this.closeBoxFile('*');
        } catch (error) {
          alert('Error uploading files. Please try again.');
          return;
        }
      } else {
        this.formData.type = 'text';
        this.$store.state.socket.timeout(1000).emit('message:send', this.formData);
      }

      this.disabledActionInput = true;
      this.isSendMessage = false;
    },

    removeDuplicateMessages(messages) {
      const uniqueMessages = new Map();
      messages.forEach((message) => {
        uniqueMessages.set(message._id, message);
      });
      return Array.from(uniqueMessages.values());
    },

    updateMessage(messages, type) {
      if (!messages || messages.length === 0) return;
      let isUnreadAdd = false;
      let lastMessage = null;
      if (this.conversation_active && this.conversation_active.readMessage) {
        lastMessage = this.conversation_active.readMessage.message;
      }

      if (type == 'unread') {
        // No todo
      } else if (type === 'previous') {
        this.old_message = this.removeDuplicateMessages([
          ...(Array.isArray(messages) ? messages : [messages]),
          ...this.old_message,
        ]);
      } else if (type === 'next') {
        if (Array.isArray(messages)) {
          this.old_message.push(...messages);
        } else {
          this.old_message.push(messages);
        }

        this.old_message = this.removeDuplicateMessages([
          ...this.old_message,
          ...(Array.isArray(messages) ? messages : [messages]),
        ]);
      } else {
        this.old_message = messages;
      }

      this.old_message.sort(
        (a, b) =>
          moment(a.created).tz(this.time_zone_local) -
          moment(b.created).tz(this.time_zone_local)
      );

      const labeledMessages = [];
      let previousDate = null;
      let id = null;

      for (const message of this.old_message) {
        if (message.created) {
          const messageDate = this.formatDateTime(
            message.created,
            'DD/MM/YYYY'
          );
          let resultFormat = this.formatDateLabel(message.created);

          if (messageDate !== previousDate) {
            labeledMessages.push({
              _id: `${this.keyClass}-date-label___${message._id}`,
              text: resultFormat.text,
              isLabel: true,
              type: 'time',
              type_data: 'common',
            });
            previousDate = messageDate;
          }

          if (
            !isUnreadAdd &&
            lastMessage &&
            moment(message.created).tz(this.time_zone_local) >
            moment(lastMessage.created).tz(this.time_zone_local) &&
            message.from._id !== this.userLogin.uid
          ) {
            labeledMessages.push({
              _id: `${this.keyClass}-unread-label___${message._id}`,
              text: '',
              type: 'unread',
              type_data: 'common',
            });
            isUnreadAdd = true;
          }

          message.show_full_date = resultFormat.isDate;
          message.type_data = 'common';
        }

        if (id != message._id) {
          labeledMessages.push(message);
          id = message._id;
        }
      }

      const filteredMessages = labeledMessages.filter(
        (item) => item.type_data === 'common'
      );

      if (this.isShowUnreadMessage) {
        this.list_message = filteredMessages.filter(
          (item) => item.type != 'unread'
        );
      } else {
        this.list_message = filteredMessages;
      }
    },

    initChat() {
      if (this.$store.state.socket && !this.$store.state.socket.connected) {
        this.$store.state.socket.connect();
      }

      this.$store.state.socket.off("user:countUnread")
      this.$store.state.socket.on("user:countUnread", (data) => {
        this.$store.dispatch('CountUnreadAction', data.unread)
        if (data.unread > 0) {
           this.emit_conversation_list(0,this.list_conversation.conversations.length)
        }
      })

      // List conversation
      this.$store.state.socket.emit('conversation:list', {
        offset: 0,
        limit: this.limit,
        keyword: '',
      });
      this.$store.state.socket.on('conversation:list', async (data) => {
        if (
          this.isLoadConversation &&
          this.isNextConversation &&
          this.list_conversation.conversations.length > 0
        ) {
          if (data.conversations.length > 0) {
            this.list_conversation.conversations.push(...data.conversations);
            // Normalize tags for newly loaded conversations
            (data.conversations || []).forEach(c => {
              const normalized = this.getConversationTags(c);
              this.$set(c, 'tags', normalized);
            });
            this.list_conversation.offset = this.list_conversation.conversations.length;
          }

          this.isLoadConversation = false;
        } else {
          this.list_conversation.offset = data.conversations.length;
          this.list_conversation.conversations = data.conversations;
          // Normalize tags for left menu rendering
          (this.list_conversation.conversations || []).forEach(c => {
            const normalized = this.getConversationTags(c);
            this.$set(c, 'tags', normalized);
          });
          this.list_conversation.limit = this.limit;
        }

        if (data.conversations.length < this.limit) {
          this.isNextConversation = false;
        }
      });

      // 👉 DÁN ĐOẠN conversation:update VÀO ĐÂY
  this.$store.state.socket.off("conversation:update");
this.$store.state.socket.on("conversation:update", (conversation) => {
  if (!conversation || !conversation._id) return;

  // update active
  if (this.conversation_active && String(this.conversation_active._id) === String(conversation._id)) {
    this.$set(this.conversation_active, "tag_str", conversation.tag_str);
    const normalized = this.getConversationTags(this.conversation_active);
    this.$set(this.conversation_active, "tags", normalized);
  }

  // update left menu list
  const idx = (this.list_conversation?.conversations || []).findIndex(
    c => String(c._id) === String(conversation._id)
  );
  if (idx !== -1) {
    this.$set(this.list_conversation.conversations[idx], "tag_str", conversation.tag_str);
    const normalized = this.getConversationTags(this.list_conversation.conversations[idx]);
    this.$set(this.list_conversation.conversations[idx], "tags", normalized);
  }
});


      // Message
      this.$store.state.socket.on('message:list', async (data) => {
        if (data.type == 'initial') {
          const filteredMessages = data.messages.filter(
            (message) =>
              message.conversation_id === this.conversation_active._id
          );
          this.updateMessage(filteredMessages, 'initial');
          await this.$nextTick();
          const chatContentRef = this.$refs.chatContentRef;
          if (chatContentRef) {
            chatContentRef.scrollTop = chatContentRef.scrollHeight;
          }
        } else if (data.type == 'previous') {
          if (data.messages.length < this.limit) {
            this.isPrev = false;
          }

          const oldScrollHeight =
            this.$refs.chatContentRef?.scrollHeight || 0;
          const filteredMessages = data.messages.filter(
            (message) =>
              message.conversation_id === this.conversation_active._id
          );
          this.updateMessage(filteredMessages, 'previous');
          await this.$nextTick();
          const newScrollHeight =
            this.$refs.chatContentRef?.scrollHeight || 0;
          this.$refs.chatContentRef.scrollTop =
            newScrollHeight - oldScrollHeight;
        } else if (data.type == 'next') {
          if (data.messages.length < this.limit) {
            this.isNext = false;
          }

          const filteredMessages = data.messages.filter(
            (message) =>
              message.conversation_id === this.conversation_active._id
          );
          this.updateMessage(filteredMessages, 'next');
          await this.$nextTick();
          setTimeout(() => {
            this.scrollToEndChat();
          }, 200);
        }
      });

      this.$store.state.socket.on('message:read', (data) => {
        this.isShowUnreadMessage = true;
        this.updateMessage(data, 'unread');
      });

      this.$store.state.socket.on('message:send', (data) => {

        if (this.conversation_active && data.conversation_id === this.conversation_active._id) {
          this.disabledActionInput = false;
          this.isSendMessage = false;

          this.updateMessage(data, 'next');
          this.formData.message = '';
          this.formData.type = 'text';
          this.formData.file_ids = [];
          this.formData.payload = '';
          this.formData.reply_id = '';
          this.$store.state.socket.emit('conversation:list', {
            offset: 0,
            limit: this.limit,
            keyword: '',
          });
        }
        setTimeout(() => {
          this.scrollToEndChat();
        }, 200);
      });
    },

    async onFileChange(event, type) {
      const files = event.target.files;
      if (type === 'image') {
        if (this.fileImages.length + files.length > this.maxFileUpload) {
          this.isBoxImage = true
          alert(`You can only upload a maximum of ${this.maxFileUpload} images.`)
          return
        }

        this.openBoxFile('image');
        this.fileVideos = [];
        this.fileVideoPreview = [];
        this.formData.type = 'media';
        for (let i = 0; i < files.length; i++) {
          const file = files[i];

          // Validate file
          if (!ALLOWED_FILE_TYPES.includes(file.type)) {
            alert('Only PNG, JPG, and JPEG files are allowed.');
            continue;
          }

          if (file.size > MAX_FILE_SIZE) {
            alert('File size exceeds the 50MB limit.');
            return;
          }

          // Create thumbnail
          this.createThumbnailFromImage(file, (thumbnail) => {
            this.fileImages.push({ image: file, thumbnail });
          });

          const reader = new FileReader();
          reader.onload = (e) => {
            this.fileImagePreview.push(e.target.result);
          };
          reader.readAsDataURL(file);
        }
      } else if (type === 'video') {
        if (this.fileVideos.length + files.length > this.maxFileUpload) {
          this.isBoxImage = true
          alert(`You can only upload a maximum of ${this.maxFileUpload} videos.`)
          return
        }

        this.openBoxFile('video');
        this.fileImages = [];
        this.fileImagePreview = [];
        this.formData.type = 'media';

        if (this.$refs.videoRef.src) {
          URL.revokeObjectURL(this.$refs.videoRef.src);
          this.$refs.videoRef.src = '';
        }

        for (let i = 0; i < files.length; i++) {
          const file = files[i];

          if (file.size > MAX_FILE_SIZE) {
            alert('File size exceeds the 50MB limit.');
            return;
          }

          // Create thumbnail
          const url = URL.createObjectURL(file);
          this.$refs.videoRef.src = url;
          this.$refs.videoRef.load();

          const onLoadedData = () => {
            this.createThumbnailFromVideo(file, (thumbnail, filePreview) => {
              this.fileVideos.push({ video: file, thumbnail });
              this.fileVideoPreview.push(filePreview);
            });

            URL.revokeObjectURL(url);
            this.$refs.videoRef.removeEventListener('loadeddata', onLoadedData);
          };

          this.$refs.videoRef.addEventListener('loadeddata', onLoadedData, {
            once: true,
          });
        }
      } else if (type === 'pdf') {
        const file = files[0];

        // Validate file
        if (file.type != 'application/pdf') {
          alert('Only PDF files are allowed.');
          return;
        }

        if (file.size > MAX_FILE_SIZE) {
          alert('File size exceeds the 50MB limit.');
          return;
        }

        const form = new FormData();
        form.append('file', file);
        let that = this;
        ApiRepository.post(`${this.domain}/api/upload`, form, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'App-type': 'admin',
            Authorization: 'Bearer ' + that.userLogin.token,
          },
        })
          .then(function (response) {
            that.formData.file_ids.push(response.data.data._id);
            that.formData.message = null;
            that.formData.type = 'pdf';
            that.socket.emit('message:send', that.formData);
            that.closeBoxFile('*');
          })
          .catch(function (error) {
            var message = error.response.data.message;
            console.error('There was an error!', message);
            switch (message) {
              case 'INVALID_TOKEN_ERR':
                alert(this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN);
                location.reload();
                break;
              default:
                alert(this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN);
            }
          });
      }

      // Remove image when upload (cache image)
      event.target.value = '';
    },

    async removeFileItem(index, type) {
      if (type == 'image') {
        const previewUrl = this.fileImagePreview[index];
        URL.revokeObjectURL(previewUrl);
        this.fileImages.splice(index, 1);
        this.fileImagePreview.splice(index, 1);
      } else if (type == 'video') {
        const previewUrl = this.fileVideoPreview[index];
        const thumbnailUrl = this.fileVideos[index].thumbnail;

        if (thumbnailUrl) {
          URL.revokeObjectURL(thumbnailUrl);
        }
        URL.revokeObjectURL(previewUrl);

        this.fileVideos.splice(index, 1);
        this.fileVideoPreview.splice(index, 1);
      }

      if (this.fileImagePreview.length == 0) {
        this.isBoxImage = false;
      }

      if (this.fileVideoPreview.length == 0) {
        this.isBoxVideo = false;
      }
    },

    createThumbnailFromImage(file, callback) {
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const maxWith = 84;
          const maxHeight = 84;
          canvas.width = maxWith;
          canvas.height = maxHeight;
          const cropSize = Math.min(img.width, img.height);
          const cropX = (img.width - cropSize) / 2;
          const cropY = (img.height - cropSize) / 2;
          ctx.drawImage(
            img,
            cropX,
            cropY,
            cropSize,
            cropSize,
            0,
            0,
            maxWith,
            maxHeight
          );
          canvas.toBlob((blob) => {
            const originalName = file.name;
            const fileExtension = originalName.split('.').pop();
            const fileName = originalName.replace(/\.[^/.]+$/, '');
            const thumbnailName = `${fileName}_thumbnail.${fileExtension}`;
            const fileThumb = new File([blob], thumbnailName, {
              type: file.type,
            });
            callback(fileThumb);
          }, file.type);
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    },

    createThumbnailFromVideo(file, callback) {
      const canvas = document.createElement('canvas');
      const video = document.createElement('video');
      const videoUrl = URL.createObjectURL(file);
      video.src = videoUrl;
      video.muted = true;
      video.preload = 'auto';

      const cleanup = () => {
        URL.revokeObjectURL(videoUrl);
        video.remove();
      };

      video.addEventListener('error', (e) => {
        console.error('Video load error:', e);
        cleanup();
      });

      video.addEventListener('loadeddata', () => {
        const targetWidth = 84;
        const targetHeight = 84;
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const context = canvas.getContext('2d');
        video.currentTime = 1;
        video.addEventListener('seeked', async () => {
          try {
            const imageBitmap = await createImageBitmap(
              video,
              0,
              0,
              video.videoWidth,
              video.videoHeight
            );
            const videoAspect = video.videoWidth / video.videoHeight;
            const canvasAspect = targetWidth / targetHeight;
            let sx, sy, sWidth, sHeight;
            if (videoAspect > canvasAspect) {
              sHeight = video.videoHeight;
              sWidth = sHeight * canvasAspect;
              sx = (video.videoWidth - sWidth) / 2;
              sy = 0;
            } else {
              sWidth = video.videoWidth;
              sHeight = sWidth / canvasAspect;
              sx = 0;
              sy = (video.videoHeight - sHeight) / 2;
            }
            context.clearRect(0, 0, targetWidth, targetHeight);
            context.drawImage(
              imageBitmap,
              sx,
              sy,
              sWidth,
              sHeight,
              0,
              0,
              targetWidth,
              targetHeight
            );
            canvas.toBlob((blob) => {
              const originalName = file.name;
              const fileName = originalName.replace(/\.[^/.]+$/, '');
              const thumbnailName = `${fileName}_thumbnail.jpeg`;
              const fileThumb = new File([blob], thumbnailName, {
                type: 'image/jpeg',
              });
              const filePreview = URL.createObjectURL(fileThumb);
              callback(fileThumb, filePreview);
              cleanup();
            }, 'image/jpeg');
            URL.revokeObjectURL(video.src);
          } catch (error) {
            console.error('Error creating thumbnail:', error);
            cleanup();
          }
        });
      });
    },

    handleGetId(type) {
      if (!type || !this.list_message.length) return null;

      if (type === 'first') {
        return (
          this.list_message
            .find((item) => item._id.split('___').pop() !== 'label_rent_buy')
            ?._id.split('___')
            .pop() || null
        );
      }

      if (type === 'last') {
        return (
          this.list_message
            .findLast(
              (item) => item._id.split('___').pop() !== 'label_rent_buy'
            )
            ?._id.split('___')
            .pop() || null
        );
      }

      return null;
    },

    handleChatScroll() {
      const container = this.$refs.chatContentRef;
      if (!container) return;

      const { scrollTop, scrollHeight, clientHeight } = container;

      if (scrollTop < scrollHeight - clientHeight - 5 * 70) {
        this.isScrollBottom = true;
      } else {
        this.isScrollBottom = false;
      }

      if (scrollTop === 0) {
        if (this.conversation_active && this.list_message.length > 0) {
          if (!this.isPrev) return;
          let firstId = this.handleGetId('first');
          this.$store.state.socket.emit('message:list', {
            conversation_id: this.conversation_active._id,
            message_id: firstId,
            type: 'previous',
          });
        }
      }

      if (
        scrollTop + clientHeight >= scrollHeight &&
        this.list_message.length > 0
      ) {
        if (this.conversation_active) {
          if (!this.isNext) return;
          let lastId = this.handleGetId('last');
          this.$store.state.socket.emit('message:list', {
            conversation_id: this.conversation_active._id,
            message_id: lastId,
            type: 'next',
          });
        }
      }
    },

    handleConversationScroll() {
      const container = this.$refs.chatConversationRef;
      if (!container) return;

      const { scrollTop, scrollHeight, clientHeight } = container;

      console.log('offset', this.list_conversation.conversations.length, 'limit', this.limit, 'keyword', this.keyword);
      if (
        scrollTop + clientHeight >= scrollHeight - 100 &&
        this.list_conversation.conversations.length > 0
      ) {
        if (!this.isNextConversation || this.isLoadConversation) return;
        this.emit_conversation_list(this.list_conversation.conversations.length,this.limit)
        this.isLoadConversation = true;
      }

    },

    loadPreviousMessages() {
      return new Promise((resolve) => {
        if (this.conversation_active) {
          let firstId = this.handleGetId('first');
          this.$store.state.socket.emit('message:list', {
            conversation_id: this.conversation_active._id,
            message_id: firstId,
            type: 'previous',
          });

          this.$store.state.socket.once('message:list', async (data) => {
            if (data.type === 'previous') {
              if (data.messages.length === 0) {
                this.isLoadMore = false;
              }
            }
            resolve();
          });
        } else {
          resolve();
        }
      });
    },

    updateMessageRead() {
  if (!this.conversation_active) return;

  const lastId = this.handleGetId('last');
  this.$store.state.socket.emit('message:read', {
    conversation_id: this.conversation_active._id,
    message_id: lastId,
  });

  // Tránh reload lại toàn bộ list (đặc biệt khi vào từ thông báo như 5S)
  // -> chỉ update unread locally để UI phản ánh ngay
  try {
    this.$set(this.conversation_active, 'unread', 0);

    const idx = (this.list_conversation?.conversations || []).findIndex(
      (c) => c && c._id === this.conversation_active._id
    );
    if (idx !== -1) {
      this.$set(this.list_conversation.conversations[idx], 'unread', 0);
    }
  } catch (e) {
    // no-op
  }
},

countTimeToUpdateMessageRead() {
  // đảm bảo không tạo nhiều interval
  if (this.timeCount) {
    clearInterval(this.timeCount);
    this.timeCount = null;
  }

  if (this.conversation_active && this.conversation_active.unread > 0) {
    this.timeCount = setInterval(() => {
      this.updateMessageRead();
    }, 5000);
  }
},


    highlightedLink(text) {
      if (!text) {
        return {
          has_link: false,
          message: text
        }
      }

      const newText = text.replace(/(https?:\/\/[^\s]+)/g, (url) => {
        return `<a href="${url}" target="_blank" class="highlighted-text">${url}</a>`;
      })

      if (newText !== text) {
        return {
          has_link: true,
          message: newText
        }
      }

      return {
        has_link: false,
        message: text
      }
    },

    getNameChat(item) {
      return item.from._id === this.userLogin.uid ? 'You' : item.from.user_name
    },

    getItemFromPayload(payload, field) {
      if (!payload || !field) return '';

      let newPayload = null;
      if (payload.car) {
        newPayload = payload.car;
      } else if (payload.cart) {
        newPayload = payload.cart;
      }

      const fields = field.split('.');
      return fields.reduce((acc, part) => acc?.[part], newPayload);
    },

    async downLoadFileWithPath(path) {
      try {
        const fileName = this.getFileNameFromPath(path);

        const response = await axios.get(path, { responseType: 'blob' });
        const blob = new Blob([response.data], { type: response.data.type });
        const url = URL.createObjectURL(blob);

        const element = document.createElement('a');
        element.href = url;
        element.download = fileName;
        document.body.appendChild(element);
        element.click();

        setTimeout(() => {
          URL.revokeObjectURL(url);
          element.remove();
        }, 100);
      } catch (error) {
        alert('Error downloading file. Please try again.');
      }
    },

    getFileNameFromPath(path) {
      if (path == '') return '';
      return path.split('/').pop();
    },
  },

  beforeDestroy() {
    Fancybox.destroy();
    if (this.timeCount) {
      clearInterval(this.timeCount);
      this.timeCount = null;
    }
  },
};
</script>
<style lang="scss">
@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

.isLoading {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgb(255 255 255 / 70%);
  z-index: 1;

  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    svg {
      animation: loading 2s linear infinite;
    }
  }
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.line-1 {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.highlighted-text {
  text-decoration: underline;
  color: #333333;
}

.scroll-end-bottom {
  bottom: 85px;
  outline: none;
  border: none;
  background: #fff;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  left: 50%;
  right: 0;
  transform: translateX(-50%);
}

.scroll-end-bottom.show {
  animation: slide-up 0.5s forwards;
}

.loading-message {
  bottom: 10px;
  transform: translateX(-50%);
}

.highlighted {
  background-color: #cac7c71f !important;
  transition: background-color 0.3s;
  animation: pulseHighlight 1s ease-in-out;
}

.text-center-absolute {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes pulseHighlight {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.02);
  }

  100% {
    transform: scale(1);
  }
}


.p-chat {
  background: #fff;

  .p-col-12 {
    padding: 24px 16px 10px 16px;
  }
}

.chat-box {
  &.users {
    width: 472px;
    height: calc(100vh - 64px - 40px);
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #eaeaea;
  }

  .search {
    padding: 16px 16px 0;

    div {
      color: #b4b4b4;
      margin-bottom: 15px;
    }

    input {
      padding: 18px 18px 18px 40px;
      height: 48px;
      outline: none;
      font-size: 16px;
      line-height: 19px;
      border-radius: 5px;
      background: #f3f4f7 0% 0% no-repeat padding-box;
      border: 1px solid #d0d4d9;
    }

    svg {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      width: 26px;
      height: 26px;
      color: #666666;
    }
  }

  .user-card-container {
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #f3f4f7;
    height: calc(100% - 79px);

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .thumb {
    margin-right: 16px;
    width: 3.1255rem;
    height: 3.1255rem;

    img {
      border-radius: 100%;
    }
  }

  .user-card {
    padding: 16px;
    transition: all 0.3s;

    .info {
      padding-right: 10px;

      h5 {
        color: #333333;
        text-transform: capitalize;
        font-size: 16px;
        line-height: 19px;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        margin-bottom: 2px;
      }

      p {
        color: #666666;
        font-size: 14px;
        line-height: 17px;
        margin-bottom: 0;
        text-transform: capitalize;
      }
      p.line-1{
       text-transform: unset !important;
      }
    }

    .notification-timestamp {
      width: 35px;

      span {
        &.timestamp {
          color: #666666;
          font-size: 14px;
          line-height: 17px;
          text-transform: capitalize;
        }

        &.badge {
          color: #ffffff;
          text-transform: capitalize;
          font-size: 10px;
          line-height: 12px;
          background: #f5564e 0% 0% no-repeat padding-box;
          border-radius: 10px;
          padding: 6px;
        }
      }
    }

    &:hover,
    &.active {
      background: #ffdf01;
    }
  }
}

.contents {
  width: calc(100% - 472px);
  background: #f3f4f7;
  height: calc(100vh - 64px - 40px);

  .content-header,
  .content-footer {
    height: 4.543rem;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #eaeaea;
  }

  .content-header {
    padding: 8px 16px;

    .user-info {
      h5 {
        margin-bottom: 0px;
        color: #1d3118;
        font-size: 18px;
        line-height: 22px;
        color: #1d3118;
        text-transform: capitalize;
      }
    }

    .user-stats {
      margin-bottom: 0;
      list-style: none;

      li {
        margin-left: 7px;

        span {
          font-size: 14px;
          line-height: 17px;
          color: #666666;

          &:nth-child(2) {
            font-weight: bold;
            color: #333333;
          }
        }
      }
    }
  }

  .content-body {
    padding: 16px;
    padding-bottom: 0px;
    scrollbar-width: thin;
    scrollbar-color: #f3f4f7;
    overflow: hidden;
    height: calc(100% - 112px);
    overflow-y: auto;
    height: 100%;

    .date-divider {
      text-align: center;
      margin-bottom: 16px;

      span {
        color: #666666;
        font-size: 12px;
        line-height: 14px;
        padding: 8px 17px;
        background: rgb(0 0 0 / 10%) 0% 0% no-repeat padding-box;
        border-radius: 13px;
        display: inline-block;
      }
    }

    .unread-divider {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .divider-line {
        flex: 1;
        height: 2px;
        background: #000000 0% 0% no-repeat padding-box;
      }

      .divider-text {
        padding: 0 6px;
        color: #000000;
        font-size: 12px;
        line-height: 14px;
      }
    }

    .message-item {
      margin-bottom: 16px;

      .message-max-width {
        max-width: 516px;
      }

      .message-info {
        padding: 12px 16px;
        background: #fff9cb 0% 0% no-repeat padding-box;
        box-shadow: 0px 1px 2px #00000033;
        border-radius: 10px 0px 10px 10px;
        text-align: left;
        min-width: 228px;

        // Reply
        .reply-box {
          padding: 7px 8px 7px 15px;
          border-radius: 10px;
          margin-bottom: 8px;
          min-height: 38.38px;

          &::before {
            content: '';
            position: absolute;
            left: 8px;
            top: 50%;
            transform: translateY(-50%);
            height: 34px;
            width: 3px;
            background: #333333 0% 0% no-repeat padding-box;
          }

          .reply-name {
            margin-bottom: 2px;
          }

          .reply-desc {
            color: #666666;
            font-size: 12px;
            line-height: 14px;
          }

          .thumb {
            width: 34px;
            height: 34px;

            img {
              border-radius: 5px !important;
            }
          }
        }

        .message-text {
          font-size: 14px;
          line-height: 17px;
          color: #333333;
          margin-bottom: 17px;
          white-space: pre-wrap;   /* giữ \n + vẫn wrap */
          word-break: break-word;  /* tránh tràn */
        }

        .message-action {
          span {
            color: #666666;
            font-size: 12px;
            line-height: 14px;

            &:last-child {
              font-weight: bold;
            }
          }
        }
      }

      &.message-item-me {
        text-align: right;

        .message-info {
          .reply-box {
            background: #ffdf01 0% 0% no-repeat padding-box !important;
          }
        }

        &.message-item-reply {
          .thumb {
            margin-right: 5px;
          }

          .document {
            margin-right: 8px;
          }
        }
      }

      &.message-item-other {
        &.message-item-unread {
          text-align: left;
        }

        .message-info {
          background: #ffffff;
          border-radius: 0px 10px 10px 10px;

          .reply-box {
            background: #eaeaea 0% 0% no-repeat padding-box !important;
          }
        }

        .thumb {
          margin-right: 8px;
        }

        &.message-item-reply {
          .other-info {
            width: calc(100% - 3.5rem);
          }

          .document {
            margin-right: 8px;
          }
        }
      }

      .reply-name,
      .other-name {
        color: #333333;
        font-size: 12px;
        line-height: 14px;
        font-weight: bold;
        margin-bottom: 4px;
      }

      &.message-item-product {
        .message-max-width {
          max-width: 350px;
        }

        .product-card {
          background: #ffffff;
          padding: 10px;
          border-radius: 5px;

          .thumb {
            margin-right: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 3px;
            background: #f1f1f1;

            img {
              border-radius: 3px;
              height: auto;
            }
          }

          .info {
            width: calc(100% - 3.5rem);
            max-width: 243px;

            .type {
              color: #bdb4b4;
              margin-right: 5px;
            }

            .price {
              color: #333333;
            }
          }
        }
      }

      &.message-item-album {
        .message-info {
          background: transparent;
          border: none;
          box-shadow: none;
          padding: 0;
        }

        .message-box-album {
          .album-item {
            width: 80px;
            height: 80px;
            border-radius: 5px;
            margin-right: 5px;
            margin-bottom: 5px;

            img {
              border-radius: 5px;
            }
          }
        }
      }
    }
  }

  .icon-close {
    font-weight: bold;
    position: absolute;
    right: 22px;
    top: 14px;
    color: #000000;
  }

  .content-footer {
    padding: 12px 18px;

    .options {
      position: absolute;
      left: 0;
      bottom: 100%;

      .images,
      .videos {
        height: 123px;
        background: #ffffff 0% 0% no-repeat padding-box;
        padding: 10px 16px;
        border: 1px solid #eaeaea;
        border-radius: 20px 20px 0px 0px;

        h5 {
          font-size: 14px;
          line-height: 17px;
          letter-spacing: 0px;
          color: #666666;
        }

        .image-container,
        .video-container {
          width: 100%;
          overflow: hidden;
          overflow-x: auto;
          scrollbar-width: thin;
          scrollbar-color: #f3f4f7;

          .image-item,
          .video-item {
            position: relative;
            width: 77px;
            height: 77px;
            border: 1px solid #d0d4d9;
            border-radius: 5px;
            margin-right: 8px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            div {
              position: absolute;
              right: 2px;
              top: 2px;
              width: 20px;
              height: 20px;
              border-radius: 100%;
              background: #f5564e 0% 0% no-repeat padding-box;
              display: flex;
              justify-content: center;
              color: #fff;
              font-size: 14px;
              line-height: 14px;
              padding-top: 2px;
            }
          }
        }
      }
    }

    .action-button {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        margin-right: 15px;

        label {
          margin-bottom: 0;
        }

        input {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          opacity: 0;
          z-index: 10;
          display: none;
        }
      }
    }

    #chat-input {
      border: none;
      outline: none;
      background: #fff;
      font-size: 14px;
      line-height: 17px;
      resize: none;
      color: #333333;
      padding: 5px;
      max-height: 82px;
      height: 32px;
      scrollbar-width: 2px;
      scrollbar-color: #ffdf01;

      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #eaeaea;
      }

      &::-webkit-scrollbar {
        width: 6px;
        background-color: #eaeaea;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #ffdf01;
      }
    }

    #chat-input::placeholder {
      color: #b4b4b4;
    }

    #send {
      margin-left: 10px;
      outline: none;
      border: none;
      width: 41px;
      height: 41px;
      border-radius: 100%;
      background: #ffdf01;
      transition: all 0.3s;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}

.message-item-pdf {
  .title {
    text-align: left;
    width: 100%;
    padding: 0 10px;
  }

  .message-action {
    margin-top: 5px;
    background: #eaeaea 0% 0% no-repeat padding-box !important;
    padding: 5px 15px;
    border-radius: 8px;
    color: #666666;
    font-size: 12px;
    line-height: 14px;

    span {
      &:last-child {
        margin-left: 10px;
      }
    }
  }
}

span.document {
  width: 32px;
  height: 32px;
  background: #333333;
  border-radius: 5px;
}

.message-item-reply-pdf {
  .reply-info {
    width: calc(100% - 45px);
  }
}

.reply-box-chat {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  background: #ffffff;
  margin-bottom: 2px;
  padding: 12px;

  .reply-thumb {
    border-radius: 5px;
    width: 32px;
    height: 32px;
    margin-right: 4px;
    border: 1px solid rgb(77 77 77 / 41%);
  }

  &>div {
    background: #eaeaea 0% 0% no-repeat padding-box !important;
    padding: 12px 12px 12px 17px;
    border-radius: 8px;

    &::before {
      content: '';
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
      height: 34px;
      width: 3px;
      background: #333333 0% 0% no-repeat padding-box;
    }

    .reply-title {
      color: #333333;
      font-size: 12px;
      line-height: 14px;
      font-weight: bold;
      margin-bottom: 4px;
    }

    .reply-desc {
      color: #666666;
      font-size: 12px;
      line-height: 14px;
    }
  }
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 35px;
  height: 35px;
  background: #000000;
  opacity: 0.8;
  border-radius: 100%;
  transition: all 0.3s;

  &:hover {
    opacity: 1;
  }
}

.message-item-other-media {
  .message-box-album {
    .album-item {
      width: 80px;
      height: 80px;
      border-radius: 5px;
      margin-right: 5px;
      margin-bottom: 5px;

      img {
        border-radius: 5px;
      }
    }
  }
}

.timestamp-reply {
  color: #666666;
  font-size: 12px;
  line-height: 14px;
  padding: 5px 17px;
  background: rgb(0 0 0 / 10%) 0% 0% no-repeat padding-box;
  border-radius: 13px;

  .reply-action {
    font-weight: bold;
  }
}

.cursor-pointer {
  cursor: pointer;
}


.chat-tags {
  margin-left: 10px;
  gap: 6px;
  flex-wrap: wrap;
}

.chat-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 14px;
  background: #ffdf01;
  color: #1d3118;
  border: 1px solid rgba(0,0,0,0.08);
}

.chat-tag-x {
  font-weight: 700;
  cursor: pointer;
  opacity: 0.7;
}
.chat-tag-x:hover {
  opacity: 1;
}

.chat-tag-add {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid #ccc;
  background: #fff;
  cursor: pointer;
  font-weight: 700;
  line-height: 20px;
  padding: 0;
}

.tag-dialog .btn-cancel,
.tag-dialog .btn-ok {
  border: none;
  outline: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
}

.tag-dialog .btn-cancel {
  background: #eee;
  margin-right: 8px;
}
.tag-dialog .btn-ok {
  background: #ffdf01;
}
.tag-dialog .btn-ok:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chat-tags-left {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;   /* cho phép rớt dòng */
  gap: 6px;          /* khoảng cách giữa các tag */
}

.chat-tag-item-left {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 14px;
  background: #FFFFFF;
  font-weight: 400;
  font-size: 14px;
  color: #464255;

  border: 1px solid rgba(0,0,0,0.08);
  max-width: 100%;   /* tránh tràn container */
  white-space: nowrap;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

/* dropdown */
.filter-panel {
  position: absolute;
  top: 36px;
  right: 0;
  width: 220px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,.12);
  padding: 10px;
  z-index: 9999;
}
.filter-wrap{
  position: relative;
  display: flex;
  align-items: center;
}

/* Icon button */
.filter-btn, .filter-wrap img{
  border: none;
  background: transparent;
  padding: 0;
}

/* Panel */
.filter-panel{
  position: absolute;
  top: 40px;
  right: 0;
  width: 260px;
  background: #fff;
  border: 1px solid #eef0f4;
  border-radius: 14px;
  box-shadow: 0 12px 30px rgba(16, 24, 40, 0.14);
  padding: 10px 10px 12px;
  z-index: 9999;
}

/* Header */
.filter-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 4px 10px;
  border-bottom: 1px solid #f0f2f5;
}

.filter-title{
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
}

.filter-close{
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #f7f8fa;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
}
.filter-close:hover{
  background: #eef0f4;
}

/* Options grid */
.filter-options{
  padding: 10px 4px 6px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 10px;
  max-height: 220px;
  overflow: auto;
}

/* Option row */
.filter-option{
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 10px;
  cursor: pointer;
  user-select: none;
}
.filter-option:hover{
  background: #f7f8fa;
}

.filter-check{
  width: 14px;
  height: 14px;
  accent-color: #2b5cff;
}

.filter-label{
  font-size: 14px;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Footer buttons */
.filter-footer{
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 4px 0;
  border-top: 1px solid #f0f2f5;
  margin-top: 6px;
}

.btn-lite{
  padding: 6px 10px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
}
.btn-lite:hover{
  background: #f7f8fa;
}

.btn-primary{
  padding: 6px 12px;
  border-radius: 10px;
  border: 1px solid #2b5cff;
  background: #2b5cff;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}
.btn-primary:hover{
  filter: brightness(0.95);
}
.filter-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* icon */
.filter-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

/* red dot */
.filter-dot {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background: #ff3b30; /* đỏ chuẩn iOS */
  border-radius: 50%;
  border: 2px solid #fff; /* viền trắng cho nổi */
}


/* ===== Tag Filter Popover - clean UI ===== */

.filter-wrap{
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* red dot (trạng thái đang filter) */
.filter-dot{
  position: absolute;
  top: -3px;
  right: -3px;
  width: 9px;
  height: 9px;
  background: #ff3b30;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,.15);
}

/* panel */
.filter-panel{
  position: absolute;
  top: 40px;
  right: 0;
  width: 300px;
  background: #fff;
  border: 1px solid #eef0f4;
  border-radius: 16px;
  box-shadow: 0 18px 40px rgba(16,24,40,.16);
  padding: 12px;
  z-index: 9999;
}

/* little arrow */
.filter-panel::before{
  content:"";
  position:absolute;
  top:-8px;
  right:16px;
  width:14px;
  height:14px;
  background:#fff;
  border-left:1px solid #eef0f4;
  border-top:1px solid #eef0f4;
  transform: rotate(45deg);
}

/* header */
.filter-header{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:8px;
  padding: 4px 2px 10px;
  border-bottom: 1px solid #f0f2f5;
}
.filter-title{
  font-size: 13px;
  font-weight: 800;
  color: #111827;
}
.filter-close{
  width: 30px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid transparent;
  background: #f7f8fa;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  transition: .15s;
}
.filter-close:hover{
  background:#eef0f4;
}

/* options (2 columns like your screenshot) */
.filter-options{
  padding: 12px 2px 2px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  max-height: 230px;
  overflow: auto;

  /* nicer scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgba(0,0,0,.18) transparent;
}
.filter-options::-webkit-scrollbar{
  width: 8px;
}
.filter-options::-webkit-scrollbar-thumb{
  background: rgba(0,0,0,.18);
  border-radius: 999px;
}
.filter-options::-webkit-scrollbar-track{
  background: transparent;
}

/* each option row */
.filter-option{
  display:flex;
  align-items:center;
  gap:10px;
  padding: 10px 10px;
  border-radius: 14px;
  border: 1px solid #f0f2f5;
  background: #fff;
  cursor: pointer;
  user-select: none;
  transition: all .15s ease;
}
.filter-option:hover{
  background:#f7f8fa;
  border-color:#e5e7eb;
  transform: translateY(-1px);
}

/* checkbox */
.filter-check{
  width: 16px;
  height: 16px;
  accent-color: #ffdf01; /* match theme */
}

/* label */
.filter-label{
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* footer */
.filter-footer{
  display:flex;
  justify-content:flex-end;
  gap:10px;
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid #f0f2f5;
}

/* buttons */
.btn-lite{
  height: 36px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: .15s;
}
.btn-lite:hover{
  background:#f7f8fa;
}

.btn-primary{
  height: 36px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid #ffdf01;
  background: #ffdf01;
  color: #000;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  transition: .15s;
}
.btn-primary:hover{
  opacity: .9;
}


</style>
